<template>
  <div v-loading="loading">
    <div v-if="version == 1">
      <div v-if="type == 'XSD'">
        <p class="center">{{ enterpriseName }}</p>
        <p class="divider"></p>
        <p class="center">单号: {{ templateHeadData.billNo }}</p>
        <p class="center">{{ templateHeadData.customerName }}</p>
        <div class="center dividerBox">
          <p class="divider"></p>
          <span>销售单<span v-if="templateHeadData.billStatus">({{ templateHeadData.billStatus }})</span></span>
        </div>
        <div class="productCard" v-for="(item, index) in templateDetailData" :key="item.id">
          <p>
            <span>{{ index + 1 }}.</span>
            <span>{{ item.itemName }}</span>
            <span>({{ item.itemSpec }})</span>
            <span v-if="item.priceTypeDesc">({{ item.priceTypeDesc }})</span>
          </p>
          <productTemplate :printData="printData" :item="item"></productTemplate>
          <!-- <div v-if="printData['salPriceFormat' + 'IsShow'] == 'Y' || printData['midPriceFormat' + 'IsShow'] == 'Y' || printData['invPriceFormat' + 'IsShow'] == 'Y'">
          <p>
            <span v-if="printData['invQtyFormat' + 'IsShow'] == 'Y'">{{item.invQtyFormat}}</span>
            <span v-else>{{item.billQtyFormat}}</span>
          </p>
          <p class="flex justify_space-between">
            <span>
              <span v-if="printData['salPriceFormat' + 'IsShow'] == 'Y'">{{item.salPriceFormat}}</span>
              <span v-if="printData['midPriceFormat' + 'IsShow'] == 'Y'">{{item.midPriceFormat}}</span>
              <span v-if="printData['invPriceFormat' + 'IsShow'] == 'Y'">{{item.invPriceFormat}}</span>
            </span>
            <span>{{item.totalAmt}}元</span>
          </p>
        </div>
        <div v-else>
          <p class="flex justify_space-between">
            <span v-if="printData['invQtyFormat' + 'IsShow'] == 'Y'">{{item.invQtyFormat}}</span>
            <span v-else>{{item.billQtyFormat}}</span>
            <span>{{item.totalAmt}}元</span>
          </p>
        </div>
        <p v-if="printData['salBarCode' + 'IsShow'] == 'Y' && item.salBarCode">大单位条码：{{item.salBarCode}}</p>
        <p v-if="printData['midBarCode' + 'IsShow'] == 'Y' && item.midBarCode">中单位条码：{{item.midBarCode}}</p>
        <p v-if="printData['invBarCode' + 'IsShow'] == 'Y' && item.invBarCode">小单位条码：{{item.invBarCode}}</p>
        <p class="flex justify_space-between">
          <span>
            <span v-if="printData['salRetailPrice' + 'IsShow'] == 'Y' || printData['midRetailPrice' + 'IsShow'] == 'Y' || printData['invRetailPrice' + 'IsShow'] == 'Y'">建议零售价：</span>
            <span v-if="printData['salRetailPrice' + 'IsShow'] == 'Y'">{{item.salRetailPrice}}</span>
            <span v-if="printData['midRetailPrice' + 'IsShow'] == 'Y'">{{item.midRetailPrice}}</span>
            <span v-if="printData['invRetailPrice' + 'IsShow'] == 'Y'">{{item.invRetailPrice}}</span>
          </span>
          <span v-if="printData['itemWeight' + 'IsShow'] == 'Y'">重量：{{item.itemWeight}}</span>
        </p>
        <p class="flex justify_space-between">
          <span v-if="printData['productFactoryName' + 'IsShow'] == 'Y' && item.productFactoryName">生产厂家：{{item.productFactoryName}}</span>
          <span v-if="printData['itemValid' + 'IsShow'] == 'Y'">保质期：{{item.itemValid}}</span>
        </p> -->
        </div>
        <!-- <p class="divider"></p>
      <div class="tableHead">
        <span class="th">商品</span>
        <span class="th">数量</span>
        <span class="th">单价</span>
        <span class="th">金额</span>
        <span class="th">备注</span>
      </div>
      <p class="divider"></p>
      <div class="tableBody">
        <p class="product">
          <span class="td">1. 蒙牛特仑苏</span>
          <span class="td">条码：7777</span>
        </p>
        <p class="tableHead">
          <span class="td"></span>
          <span class="td">6箱</span>
          <span class="td">100元</span>
          <span class="td">600元</span>
          <span class="td">正常销售111111111</span>
        </p>
        <p class="product">
          <span class="td">保质期: 365天</span>
          <span class="td">建议零售价: 140.00 /箱</span>
          <span class="td">生产日期: 2015-02-05</span>
          <span class="td">重量: 22吨</span>
          <span class="td">多口味: 原味</span>
        </p>
      </div> -->
        <p class="divider"></p>
        <p class="flex justify_space-between">
          <span>销售总价：{{ templateHeadData.totalAmt }}元</span>
          <span>折扣金额：{{ templateHeadData.discountAmt }}元</span>
        </p>
        <p class="flex justify_space-between">
          <span>冲抵预收：{{ templateHeadData.prePayAmt }}元</span>
          <span>新增欠款：{{ templateHeadData.arrearAmt }}元</span>
        </p>
        <p>抵扣退货金额：{{ templateHeadData.returnOffsetAmt }}元</p>
        <p>实收金额：{{ templateHeadData.payAmt }}元</p>
        <p>交易账户：{{ templateHeadData.accountName }}</p>
        <p v-if="printData['orderBillNo' + 'IsShow'] == 'Y' && templateHeadData.orderBillNo">来源单号：{{ templateHeadData.orderBillNo }}</p>
      </div>
      <div v-else-if="type == 'HHD'">
        <p class="center">{{ enterpriseName }}</p>
        <p class="divider"></p>
        <p class="center">单号: {{ templateHeadData.billNo }}</p>
        <p class="center">{{ templateHeadData.customerName }}</p>
        <div class="center dividerBox">
          <p class="divider"></p>
          <span>还货单<span v-if="templateHeadData.billStatus">({{ templateHeadData.billStatus }})</span></span>
        </div>
        <div class="productCard" v-for="(item, index) in templateDetailData" :key="item.id">
          <p>
            <span>{{ index + 1 }}.</span>
            <span>{{ item.itemName }}</span>
            <span>({{ item.itemSpec }})</span>
            <span v-if="item.priceTypeDesc">({{ item.priceTypeDesc }})</span>
            <span v-if="item.salOrderMeetName">({{ item.salOrderMeetName }})</span>
          </p>
          <productTemplate :printData="printData" :item="item"></productTemplate>
          <p v-if="printData['surplusQtyFormat' + 'IsShow'] == 'Y'">
            <span>余货数量：{{ item.surplusQtyFormat }}</span>
          </p>
          <!-- <div v-if="printData['salPriceFormat' + 'IsShow'] == 'Y' || printData['midPriceFormat' + 'IsShow'] == 'Y' || printData['invPriceFormat' + 'IsShow'] == 'Y'">
          <p>
            <span>{{item.billQtyFormat}}</span>
          </p>
          <p class="flex justify_space-between">
            <span>
              <span v-if="printData['salPriceFormat' + 'IsShow'] == 'Y'">{{item.salPriceFormat}}</span>
              <span v-if="printData['midPriceFormat' + 'IsShow'] == 'Y'">{{item.midPriceFormat}}</span>
              <span v-if="printData['invPriceFormat' + 'IsShow'] == 'Y'">{{item.invPriceFormat}}</span>
            </span>
            <span>{{item.totalAmt}}元</span>
          </p>
        </div>
        <div v-else>
          <p class="flex justify_space-between">
            <span>{{item.billQtyFormat}}</span>
            <span>{{item.totalAmt}}元</span>
          </p>
        </div>
        <p v-if="printData['salBarCode' + 'IsShow'] == 'Y' && item.salBarCode">大单位条码：{{item.salBarCode}}</p>
        <p v-if="printData['midBarCode' + 'IsShow'] == 'Y' && item.midBarCode">中单位条码：{{item.midBarCode}}</p>
        <p v-if="printData['invBarCode' + 'IsShow'] == 'Y' && item.invBarCode">小单位条码：{{item.invBarCode}}</p>
        <p class="flex justify_space-between">
          <span>
            <span v-if="printData['salRetailPrice' + 'IsShow'] == 'Y' || printData['midRetailPrice' + 'IsShow'] == 'Y' || printData['invRetailPrice' + 'IsShow'] == 'Y'">建议零售价：</span>
            <span v-if="printData['salRetailPrice' + 'IsShow'] == 'Y'">{{item.salRetailPrice}}</span>
            <span v-if="printData['midRetailPrice' + 'IsShow'] == 'Y'">{{item.midRetailPrice}}</span>
            <span v-if="printData['invRetailPrice' + 'IsShow'] == 'Y'">{{item.invRetailPrice}}</span>
          </span>
          <span v-if="printData['itemWeight' + 'IsShow'] == 'Y'">重量：{{item.itemWeight}}</span>
        </p>
        <p class="flex justify_space-between">
          <span v-if="printData['productFactoryName' + 'IsShow'] == 'Y' && item.productFactoryName">生产厂家：{{item.productFactoryName}}</span>
          <span v-if="printData['itemValid' + 'IsShow'] == 'Y'">保质期：{{item.itemValid}}</span>
        </p> -->
        </div>
        <p class="divider"></p>
        <p class="flex justify_space-between">
          <span>销售总价：{{ templateHeadData.totalAmt }}元</span>
          <span>折扣金额：{{ templateHeadData.discountAmt }}元</span>
        </p>
        <p class="flex justify_space-between">
          <span>冲抵预收：{{ templateHeadData.prePayAmt }}元</span>
          <span>新增欠款：{{ templateHeadData.arrearAmt }}元</span>
        </p>
        <p>抵扣退货金额：{{ templateHeadData.returnOffsetAmt }}元</p>
        <p>交易账户：{{ templateHeadData.accountName }}</p>
        <p v-if="printData['orderBillNo' + 'IsShow'] == 'Y' && templateHeadData.orderBillNo">来源单号：{{ templateHeadData.orderBillNo }}</p>
      </div>
      <div v-else-if="type == 'XST'">
        <p class="center">{{ enterpriseName }}</p>
        <p class="divider"></p>
        <p class="center">单号: {{ templateHeadData.billNo }}</p>
        <p class="center">{{ templateHeadData.customerName }}</p>
        <div class="center dividerBox">
          <p class="divider"></p>
          <span>销售退货单<span v-if="templateHeadData.billStatus">({{ templateHeadData.billStatus }})</span></span>
        </div>
        <div class="productCard" v-for="(item, index) in templateDetailData" :key="item.id">
          <p>
            <span>{{ index + 1 }}.</span>
            <span>{{ item.itemName }}</span>
            <span>({{ item.itemSpec }})</span>
            <span v-if="item.priceTypeDesc">({{ item.priceTypeDesc }})</span>
            <span v-if="item.causeDesc">({{ item.causeDesc }})</span>
          </p>
          <productTemplate :printData="printData" :item="item"></productTemplate>
          <!-- <div v-if="printData['salPriceFormat' + 'IsShow'] == 'Y' || printData['midPriceFormat' + 'IsShow'] == 'Y' || printData['invPriceFormat' + 'IsShow'] == 'Y'">
          <p>
            <span>{{item.billQtyFormat}}</span>
          </p>
          <p class="flex justify_space-between">
            <span>
              <span v-if="printData['salPriceFormat' + 'IsShow'] == 'Y'">{{item.salPriceFormat}}</span>
              <span v-if="printData['midPriceFormat' + 'IsShow'] == 'Y'">{{item.midPriceFormat}}</span>
              <span v-if="printData['invPriceFormat' + 'IsShow'] == 'Y'">{{item.invPriceFormat}}</span>
            </span>
            <span>{{item.totalAmt}}元</span>
          </p>
        </div>
        <div v-else>
          <p class="flex justify_space-between">
            <span>{{item.billQtyFormat}}</span>
            <span>{{item.totalAmt}}元</span>
          </p>
        </div>
        <p v-if="printData['salBarCode' + 'IsShow'] == 'Y' && item.salBarCode">大单位条码：{{item.salBarCode}}</p>
        <p v-if="printData['midBarCode' + 'IsShow'] == 'Y' && item.midBarCode">中单位条码：{{item.midBarCode}}</p>
        <p v-if="printData['invBarCode' + 'IsShow'] == 'Y' && item.invBarCode">小单位条码：{{item.invBarCode}}</p>
        <p class="flex justify_space-between">
          <span>
            <span v-if="printData['salRetailPrice' + 'IsShow'] == 'Y' || printData['midRetailPrice' + 'IsShow'] == 'Y' || printData['invRetailPrice' + 'IsShow'] == 'Y'">建议零售价：</span>
            <span v-if="printData['salRetailPrice' + 'IsShow'] == 'Y'">{{item.salRetailPrice}}</span>
            <span v-if="printData['midRetailPrice' + 'IsShow'] == 'Y'">{{item.midRetailPrice}}</span>
            <span v-if="printData['invRetailPrice' + 'IsShow'] == 'Y'">{{item.invRetailPrice}}</span>
          </span>
          <span v-if="printData['itemWeight' + 'IsShow'] == 'Y'">重量：{{item.itemWeight}}</span>
        </p>
        <p class="flex justify_space-between">
          <span v-if="printData['productFactoryName' + 'IsShow'] == 'Y' && item.productFactoryName">生产厂家：{{item.productFactoryName}}</span>
          <span v-if="printData['itemValid' + 'IsShow'] == 'Y'">保质期：{{item.itemValid}}</span>
        </p> -->
        </div>
        <p class="divider"></p>
        <p class="flex justify_space-between">
          <span>退货总价：{{ templateHeadData.totalAmt }}元</span>
          <span>折扣金额：{{ templateHeadData.discountAmt }}元</span>
        </p>
        <p class="flex justify_space-between">
          <span>新增预收：{{ templateHeadData.prePayAmt }}元</span>
          <span>冲抵欠款：{{ templateHeadData.arrearAmt }}元</span>
        </p>
        <p>冲抵销售金额：{{ templateHeadData.offsetSalAmt }}元</p>
        <p>实付金额：{{ templateHeadData.payAmt }}元</p>
        <p v-if="printData['returnOrderBillNo' + 'IsShow'] == 'Y' && templateHeadData.returnOrderBillNo">退货单号：{{ templateHeadData.returnOrderBillNo }}</p>
      </div>
      <div v-else-if="type == 'XTY'">
        <p class="center">{{ enterpriseName }}</p>
        <p class="divider"></p>
        <p class="center">单号: {{ templateHeadData.billNo }}</p>
        <p class="center">{{ templateHeadData.customerName }}</p>
        <div class="center dividerBox">
          <p class="divider"></p>
          <span>退货订单<span v-if="templateHeadData.billStatus">({{ templateHeadData.billStatus }})</span></span>
        </div>
        <div class="productCard" v-for="(item, index) in templateDetailData" :key="item.id">
          <p>
            <span>{{ index + 1 }}.</span>
            <span>{{ item.itemName }}</span>
            <span>({{ item.itemSpec }})</span>
            <span v-if="item.priceTypeDesc">({{ item.priceTypeDesc }})</span>
            <span v-if="item.causeDesc">({{ item.causeDesc }})</span>
          </p>
          <productTemplate :printData="printData" :item="item"></productTemplate>
          <!-- <div v-if="printData['salPriceFormat' + 'IsShow'] == 'Y' || printData['midPriceFormat' + 'IsShow'] == 'Y' || printData['invPriceFormat' + 'IsShow'] == 'Y'">
          <p>
            <span>{{item.billQtyFormat}}</span>
          </p>
          <p class="flex justify_space-between">
            <span>
              <span v-if="printData['salPriceFormat' + 'IsShow'] == 'Y'">{{item.salPriceFormat}}</span>
              <span v-if="printData['midPriceFormat' + 'IsShow'] == 'Y'">{{item.midPriceFormat}}</span>
              <span v-if="printData['invPriceFormat' + 'IsShow'] == 'Y'">{{item.invPriceFormat}}</span>
            </span>
            <span>{{item.totalAmt}}元</span>
          </p>
        </div>
        <div v-else>
          <p class="flex justify_space-between">
            <span>{{item.billQtyFormat}}</span>
            <span>{{item.totalAmt}}元</span>
          </p>
        </div>
        <p v-if="printData['salBarCode' + 'IsShow'] == 'Y' && item.salBarCode">大单位条码：{{item.salBarCode}}</p>
        <p v-if="printData['midBarCode' + 'IsShow'] == 'Y' && item.midBarCode">中单位条码：{{item.midBarCode}}</p>
        <p v-if="printData['invBarCode' + 'IsShow'] == 'Y' && item.invBarCode">小单位条码：{{item.invBarCode}}</p>
        <p class="flex justify_space-between">
          <span>
            <span v-if="printData['salRetailPrice' + 'IsShow'] == 'Y' || printData['midRetailPrice' + 'IsShow'] == 'Y' || printData['invRetailPrice' + 'IsShow'] == 'Y'">建议零售价：</span>
            <span v-if="printData['salRetailPrice' + 'IsShow'] == 'Y'">{{item.salRetailPrice}}</span>
            <span v-if="printData['midRetailPrice' + 'IsShow'] == 'Y'">{{item.midRetailPrice}}</span>
            <span v-if="printData['invRetailPrice' + 'IsShow'] == 'Y'">{{item.invRetailPrice}}</span>
          </span>
          <span v-if="printData['itemWeight' + 'IsShow'] == 'Y'">重量：{{item.itemWeight}}</span>
        </p>
        <p class="flex justify_space-between">
          <span v-if="printData['productFactoryName' + 'IsShow'] == 'Y' && item.productFactoryName">生产厂家：{{item.productFactoryName}}</span>
          <span v-if="printData['itemValid' + 'IsShow'] == 'Y'">保质期：{{item.itemValid}}</span>
        </p> -->
        </div>
        <p class="divider"></p>
        <p class="flex justify_space-between">
          <span>退货总价：{{ templateHeadData.totalAmt }}元</span>
          <span>折扣金额：{{ templateHeadData.discountAmt }}元</span>
        </p>
        <p class="flex justify_space-between">
          <span>新增预收：{{ templateHeadData.prePayAmt }}元</span>
          <span>冲抵欠款：{{ templateHeadData.arrearAmt }}元</span>
        </p>
      </div>
      <div v-else-if="type == 'XSY'">
        <p class="center">{{ enterpriseName }}</p>
        <p class="divider"></p>
        <p class="center">单号: {{ templateHeadData.billNo }}</p>
        <p class="center">{{ templateHeadData.customerName }}</p>
        <div class="center dividerBox">
          <p class="divider"></p>
          <span>销售订单<span v-if="templateHeadData.billStatus">({{ templateHeadData.billStatus }})</span></span>
        </div>
        <div class="productCard" v-for="(item, index) in templateDetailData" :key="item.id">
          <p>
            <span>{{ index + 1 }}.</span>
            <span>{{ item.itemName }}</span>
            <span>({{ item.itemSpec }})</span>
            <span v-if="item.priceTypeDesc">({{ item.priceTypeDesc }})</span>
          </p>
          <productTemplate :printData="printData" :item="item"></productTemplate>
          <!-- <div v-if="printData['salPriceFormat' + 'IsShow'] == 'Y' || printData['midPriceFormat' + 'IsShow'] == 'Y' || printData['invPriceFormat' + 'IsShow'] == 'Y'">
          <p>
            <span>{{item.billQtyFormat}}</span>
          </p>
          <p class="flex justify_space-between">
            <span>
              <span v-if="printData['salPriceFormat' + 'IsShow'] == 'Y'">{{item.salPriceFormat}}</span>
              <span v-if="printData['midPriceFormat' + 'IsShow'] == 'Y'">{{item.midPriceFormat}}</span>
              <span v-if="printData['invPriceFormat' + 'IsShow'] == 'Y'">{{item.invPriceFormat}}</span>
            </span>
            <span>{{item.totalAmt}}元</span>
          </p>
        </div>
        <div v-else>
          <p class="flex justify_space-between">
            <span>{{item.billQtyFormat}}</span>
            <span>{{item.totalAmt}}元</span>
          </p>
        </div>
        <p v-if="printData['salBarCode' + 'IsShow'] == 'Y' && item.salBarCode">大单位条码：{{item.salBarCode}}</p>
        <p v-if="printData['midBarCode' + 'IsShow'] == 'Y' && item.midBarCode">中单位条码：{{item.midBarCode}}</p>
        <p v-if="printData['invBarCode' + 'IsShow'] == 'Y' && item.invBarCode">小单位条码：{{item.invBarCode}}</p>
        <p class="flex justify_space-between">
          <span>
            <span v-if="printData['salRetailPrice' + 'IsShow'] == 'Y' || printData['midRetailPrice' + 'IsShow'] == 'Y' || printData['invRetailPrice' + 'IsShow'] == 'Y'">建议零售价：</span>
            <span v-if="printData['salRetailPrice' + 'IsShow'] == 'Y'">{{item.salRetailPrice}}</span>
            <span v-if="printData['midRetailPrice' + 'IsShow'] == 'Y'">{{item.midRetailPrice}}</span>
            <span v-if="printData['invRetailPrice' + 'IsShow'] == 'Y'">{{item.invRetailPrice}}</span>
          </span>
          <span v-if="printData['itemWeight' + 'IsShow'] == 'Y'">重量：{{item.itemWeight}}</span>
        </p>
        <p class="flex justify_space-between">
          <span v-if="printData['productFactoryName' + 'IsShow'] == 'Y' && item.productFactoryName">生产厂家：{{item.productFactoryName}}</span>
          <span v-if="printData['itemValid' + 'IsShow'] == 'Y'">保质期：{{item.itemValid}}</span>
        </p> -->
        </div>
        <p class="divider"></p>
        <p class="flex justify_space-between">
          <span>销售总价：{{ templateHeadData.totalAmt }}元</span>
          <span>折扣金额：{{ templateHeadData.discountAmt }}元</span>
        </p>
        <p class="flex justify_space-between">
          <span>冲抵预收：{{ templateHeadData.prePayAmt }}元</span>
          <span>新增欠款：{{ templateHeadData.arrearAmt }}元</span>
        </p>
        <p class="flex justify_space-between">
          <span>付款类型：{{ templateHeadData.payType }}</span>
          <span>交易账户：{{ templateHeadData.accountName }}</span>
        </p>
        <p>出库库房：{{ templateHeadData.warehouseName }}</p>
      </div>
      <div v-else-if="type == 'HDD'">
        <p class="center">{{ enterpriseName }}</p>
        <p class="divider"></p>
        <p class="center">单号: {{ templateHeadData.billNo }}</p>
        <p class="center">{{ templateHeadData.customerName }}</p>
        <div class="center dividerBox">
          <p class="divider"></p>
          <span>还货订单<span v-if="templateHeadData.billStatus">({{ templateHeadData.billStatus }})</span></span>
        </div>
        <div class="productCard" v-for="(item, index) in templateDetailData" :key="item.id">
          <p>
            <span>{{ index + 1 }}.</span>
            <span>{{ item.itemName }}</span>
            <span>({{ item.itemSpec }})</span>
            <span v-if="item.priceTypeDesc">({{ item.priceTypeDesc }})</span>
            <span v-if="item.salOrderMeetName">({{ item.salOrderMeetName }})</span>
          </p>
          <productTemplate :printData="printData" :item="item"></productTemplate>
          <p v-if="printData['surplusQtyFormat' + 'IsShow'] == 'Y'">
            <span>余货数量：{{ item.surplusQtyFormat }}</span>
          </p>
          <!-- <div v-if="printData['salPriceFormat' + 'IsShow'] == 'Y' || printData['midPriceFormat' + 'IsShow'] == 'Y' || printData['invPriceFormat' + 'IsShow'] == 'Y'">
          <p>
            <span>{{item.billQtyFormat}}</span>
          </p>
          <p class="flex justify_space-between">
            <span>
              <span v-if="printData['salPriceFormat' + 'IsShow'] == 'Y'">{{item.salPriceFormat}}</span>
              <span v-if="printData['midPriceFormat' + 'IsShow'] == 'Y'">{{item.midPriceFormat}}</span>
              <span v-if="printData['invPriceFormat' + 'IsShow'] == 'Y'">{{item.invPriceFormat}}</span>
            </span>
            <span>{{item.totalAmt}}元</span>
          </p>
        </div>
        <div v-else>
          <p class="flex justify_space-between">
            <span>{{item.billQtyFormat}}</span>
            <span>{{item.totalAmt}}元</span>
          </p>
        </div>
        <p v-if="printData['salBarCode' + 'IsShow'] == 'Y' && item.salBarCode">大单位条码：{{item.salBarCode}}</p>
        <p v-if="printData['midBarCode' + 'IsShow'] == 'Y' && item.midBarCode">中单位条码：{{item.midBarCode}}</p>
        <p v-if="printData['invBarCode' + 'IsShow'] == 'Y' && item.invBarCode">小单位条码：{{item.invBarCode}}</p>
        <p class="flex justify_space-between">
          <span>
            <span v-if="printData['salRetailPrice' + 'IsShow'] == 'Y' || printData['midRetailPrice' + 'IsShow'] == 'Y' || printData['invRetailPrice' + 'IsShow'] == 'Y'">建议零售价：</span>
            <span v-if="printData['salRetailPrice' + 'IsShow'] == 'Y'">{{item.salRetailPrice}}</span>
            <span v-if="printData['midRetailPrice' + 'IsShow'] == 'Y'">{{item.midRetailPrice}}</span>
            <span v-if="printData['invRetailPrice' + 'IsShow'] == 'Y'">{{item.invRetailPrice}}</span>
          </span>
          <span v-if="printData['itemWeight' + 'IsShow'] == 'Y'">重量：{{item.itemWeight}}</span>
        </p>
        <p class="flex justify_space-between">
          <span v-if="printData['productFactoryName' + 'IsShow'] == 'Y' && item.productFactoryName">生产厂家：{{item.productFactoryName}}</span>
          <span v-if="printData['itemValid' + 'IsShow'] == 'Y'">保质期：{{item.itemValid}}</span>
        </p> -->
        </div>
        <p class="divider"></p>
        <p class="flex justify_space-between">
          <span>销售总价：{{ templateHeadData.totalAmt }}元</span>
          <span>折扣金额：{{ templateHeadData.discountAmt }}元</span>
        </p>
        <p class="flex justify_space-between">
          <span>冲抵预收：{{ templateHeadData.prePayAmt }}元</span>
          <span>新增欠款：{{ templateHeadData.arrearAmt }}元</span>
        </p>
       <p>出库库房：{{ templateHeadData.warehouseName }}</p>

      </div>
      <div v-else-if="type == 'CINV'">
        <div class="center dividerBox">
          <p class="divider"></p>
          <span>{{ templateHeadData.title }}</span>
        </div>
        <div class="productCard" v-for="(item, index) in templateDetailData" :key="item.index">
          <div class="flex justify_space-between">
            <p style="flex: 1">
              <span>{{ index + 1 }}.</span>
              <span>{{ item.itemName }}</span>
              <span>({{ item.itemSpec }})</span>
            </p>
            <p>{{ item.onhandQtyFormat }}</p>
          </div>
          <p class="flex justify_space-between">
            <span v-if="printData['availableQty' + 'IsShow'] == 'Y'">可用数量：{{ item.availableQtyFormat }}</span>
            <span v-if="printData['invPrice' + 'IsShow'] == 'Y'">单价：{{ item.invPriceFormat }}</span>
          </p>
          <p class="divider"></p>
        </div>
        <p class="flex justify_space-between">
          <span>合计：{{ templateHeadData.onhandQtySumFormat }}</span>
          <span v-if="printData['itemTotalAmt' + 'IsShow'] == 'Y'">总金额：{{ templateHeadData.itemTotalAmt }}元</span>
        </p>
      </div>
      <div v-else-if="type == 'DBD'">
        <p class="center">单号: {{ templateHeadData.billNo }}</p>
        <div class="center dividerBox">
          <p class="divider"></p>
          <span>{{ templateHeadData.title }}<span v-if="templateHeadData.billStatus">({{ templateHeadData.billStatus }})</span></span>
        </div>
        <div class="productCard" v-for="(item, index) in templateDetailData" :key="item.index">
          <p>
            <span>{{ index + 1 }}.</span>
            <span>{{ item.itemName }}</span>
            <span>({{ item.itemSpec }})</span>
          </p>
          <p class="flex justify_space-between">
            <span>数量：{{ printData['invQtyFormat' + 'IsShow'] == 'Y' ? item.invQtyFormat : item.billQtyFormat }}</span>
            <span v-if="printData['invPriceFormat' + 'IsShow'] == 'Y'">单价：{{ item.invPriceFormat }}</span>
          </p>
          <p v-if="printData['salBarCode' + 'IsShow'] == 'Y' && item.salBarCode">大单位条码：{{ item.salBarCode }}</p>
          <p v-if="printData['midBarCode' + 'IsShow'] == 'Y' && item.midBarCode">中单位条码：{{ item.midBarCode }}</p>
          <p v-if="printData['invBarCode' + 'IsShow'] == 'Y' && item.invBarCode">小单位条码：{{ item.invBarCode }}</p>
          <p v-if="printData['productionDate' + 'IsShow'] == 'Y' && item.productionDate">生产日期：{{ item.productionDate }}</p>
          <p v-if="printData['remark' + 'IsShow'] == 'Y' && item.remark">备注：{{ item.remark }}</p>
          <p class="divider"></p>
        </div>
        <p>业务员：{{ templateHeadData.salesmanName }}</p>
        <p>录入日期：{{ templateHeadData.billDate }}</p>
        <p class="flex justify_space-between">
          <span>出：{{ templateHeadData.outWarehouseName }}</span>
          <span>入：{{ templateHeadData.inWarehouseName }}</span>
        </p>
        <p>合计金额：{{ templateHeadData.totalAmt }}元</p>
        <p>备注：{{ templateHeadData.remark }}</p>
        <p class="flex justify_space-between">
          <span v-if="printData['billQtySumFormat' + 'IsShow'] == 'Y'">总数量：{{ templateDetailData[0] && templateDetailData[0].billQtySumFormat }}</span>
          <span v-if="printData['itemWeightSumFormat' + 'IsShow'] == 'Y'">总重量：{{ templateDetailData[0] && templateDetailData[0].itemWeightSumFormat }}</span>
        </p>
      </div>
      <div v-else-if="type == 'DAILY'">
        <p class="center">{{ enterpriseName }}</p>
        <div class="center dividerBox">
          <p class="divider"></p>
          <span>销售日报</span>
        </div>
        <p class="flex justify_space-between">
          <span>销售总金额：{{ templateHeadData.salTotalAmt }}元</span>
          <span>退货总金额：{{ templateHeadData.salReturnTotalAmt }}元</span>
        </p>
        <p class="flex justify_space-between">
          <span>订货总金额：{{ templateHeadData.meetTotalAmt }}元</span>
          <span>费用金额：{{ templateHeadData.feeCashAmt }}元</span>
        </p>
        <p class="flex justify_space-between">
          <span>收欠款：{{ templateHeadData.payArrearAmt }}元</span>
          <span>收预收款：{{ templateHeadData.payPrePayAmt }}元</span>
        </p>
        <p class="flex justify_space-between">
          <span>冲抵欠款：{{ templateHeadData.subArrearAmt }}元</span>
          <span>冲抵预收：{{ templateHeadData.subPrePayAmtAmt }}元</span>
        </p>
        <p class="flex justify_space-between">
          <span>新增欠款：{{ templateHeadData.addArrearAmt }}元</span>
          <span>新增预收：{{ templateHeadData.addPrePayAmtAmt }}元</span>
        </p>
        <p class="flex justify_space-between">
          <span>应收金额：{{ templateHeadData.ysAmt }}元</span>
          <span>优惠金额：{{ templateHeadData.discountAmt }}元</span>
        </p>
        <p class="flex justify_space-between">
          <span>实收金额: {{ templateHeadData.ssAmt }}元</span>
        </p>
        <p class="divider"></p>
        <p class="flex justify_space-between">
          <span>应上交金额：{{ templateHeadData.needHandPay }}元</span>
          <span>已上交款：{{ templateHeadData.handPay }}元</span>
        </p>
        <p class="divider"></p>
        <p>日期：{{ templateHeadData.beginDate + ' - ' + templateHeadData.endDate }}</p>
        <div v-if="printData['visitPrintHeadResponses' + 'IsShow'] == 'Y'">
          <div class="center dividerBox">
            <p class="divider"></p>
            <span>拜访明细</span>
          </div>
          <div v-for="(item, index) in templateHeadData.visitPrintHeadResponses" :key="index">
            <p class="center">{{ item.customerName }}</p>
            <div class="center dividerBox">
              <p class="divider"></p>
              <span>{{ item.title }}</span>
            </div>
            <p>业务员：{{ item.salesmanName }}</p>
            <p>进店时间：{{ item.inDateTime }}</p>
            <p>离店时间：{{ item.outDateTime }}</p>
            <p>停留时间：{{ item.stayDateTime }}</p>
            <p class="flex justify_space-between">
              <span>销售总价：{{ item.salTotalAmt }}元</span>
              <span>退货总价：{{ item.salReturnTotalAmt }}元</span>
            </p>
            <p class="flex justify_space-between">
              <span>现金费用：{{ item.feeCashAmt }}元</span>
              <span>订货总额：{{ item.meetTotalAmt }}元</span>
            </p>
            <p class="flex justify_space-between">
              <span>还货数量：{{ item.returnMeetQtyFormat }}</span>
              <span>换货数量：{{ item.exchangeQtyFormat }}</span>
            </p>
            <p class="flex justify_space-between">
              <span>应上交金额：{{ item.needHandPay }}元</span>
              <span>收款总额：{{ item.payTotalAmt }}元</span>
            </p>
            <!-- <p>总金额：{{item.totalAmt}}</p> -->
            <p class="flex justify_space-between" v-if="power.isPrintBalance == 'Y'">
              <span>欠款余额：{{ item.arrearAmt }}元</span>
              <span>预收款余额：{{ item.prePayAmt }}元</span>
            </p>
          </div>
        </div>
        <div v-if="printData['oldDaily' + 'IsShow'] == 'Y'">
          <div class="center dividerBox">
            <p class="divider"></p>
            <span>拜访明细</span>
          </div>
          <div v-for="(item, index) in templateHeadData.visitPrintHeadResponses" :key="index">
            <template v-if="item.needHandPay != 0 || item.salTotalAmt != 0 || item.salReturnTotalAmt != 0 || item.discountAmt != 0 || item.arrearAmtAdd != 0 || item.arrearAmtSub != 0 || item.prePayAmtAdd != 0 || item.prePayAmtSub != 0 || item.feeGoodsAmt">
              <div v-if="index != 0" class="divider"></div>
              <div>{{ `${index + 1}.门店：${item.customerName}  应上缴：${item.needHandPay}元` }}</div>
              <div>
                <span style="margin-right: 10px;" v-if="item.salTotalAmt != 0">销售：{{ item.salTotalAmt }}元</span>
                <span style="margin-right: 10px;" v-if="item.salReturnTotalAmt != 0">退货：{{ item.salReturnTotalAmt }}元</span>
                <span style="margin-right: 10px;" v-if="item.discountAmt != 0">优惠：{{ item.discountAmt }}元</span>
                <span style="margin-right: 10px;" v-if="item.arrearAmtAdd != 0">欠款增加：{{ item.arrearAmtAdd }}元</span>
                <span style="margin-right: 10px;" v-if="item.arrearAmtSub != 0">欠款减少：{{ item.arrearAmtSub }}元</span>
                <span style="margin-right: 10px;" v-if="item.prePayAmtAdd != 0">预收增加：{{ item.prePayAmtAdd }}元</span>
                <span style="margin-right: 10px;" v-if="item.prePayAmtSub != 0">预收减少：{{ item.prePayAmtSub }}元</span>
                <span style="margin-right: 10px;" v-if="item.feeGoodsAmt">{{ item.feeGoodsAmt }}</span>
              </div>
              <div class="flex justify_space-between" v-if="power.isPrintBalance == 'Y'">
                <span>剩余欠款：{{ item.arrearAmt }}元</span>
                <span>剩余预收：{{ item.prePayAmt }}元</span>
              </div>
            </template>
          </div>
        </div>
        <!-- <div class="center dividerBox">
        <p class="divider"></p>
        <span>预收信息</span>
      </div>
      <p>客户：{{}}</p>
      <p class="flex justify_space-between">
        <span>收预收款：{{templateHeadData.payPrePayAmt}}元</span>
        <span>实收：{{templateHeadData.nonCashOutstanding}}元</span>
      </p> -->
      </div>
      <div v-else-if="type == 'CXD'">
        <p class="center">{{ enterpriseName }}</p>
        <div class="center dividerBox">
            <p class="divider"></p>
            <span>{{ templateHeadData.title }}</span>
          </div>
        <p class="flex justify_space-between">
          <span>门店：{{ templateHeadData.customerName }}</span>
          <span>库房：{{ templateHeadData.warehouseName }}</span>
        </p>
        <p>业务：{{ templateHeadData.salesmanName }}</p>
        <p>时间：{{ templateHeadData.billDate }}</p>
        <div v-for="($item, $index) in templateDetailData" :key="$index">
          <div class="center dividerBox">
            <p class="divider"></p>
            <span>{{ $item.title }}</span>
          </div>
          <div v-if="$item.printItemDetailModels">
            <div class="productCard" v-for="(item, index) in $item.printItemDetailModels" :key="index">
              <p>
                <span>{{ index + 1 }}.</span>
                <span>{{ item.itemName }}</span>
                <span>({{ item.itemSpec }})</span>
                <span v-if="item.priceTypeDesc">({{ item.priceTypeDesc }})</span>
                <span v-if="item.causeDesc && ['XST', 'CHD'].includes($item.printBillType)">({{ item.causeDesc }})</span>
                <span v-if="item.salOrderMeetName && $item.printBillType == 'HHD'">({{ item.salOrderMeetName }})</span>
              </p>
              <div v-if="printData['salPriceFormat' + 'IsShow'] == 'Y' || printData['midPriceFormat' + 'IsShow'] == 'Y' || printData['invPriceFormat' + 'IsShow'] == 'Y' || printData['priceFormat' + 'IsShow'] == 'Y'">
                <p>
                  <span v-if="printData['invQtyFormat' + 'IsShow'] == 'Y'">{{ item.invQtyFormat }}</span>
                  <span v-else>{{ item.billQtyFormat }}</span>
                </p>
                <p class="flex justify_space-between">
                  <span v-if="printData['priceFormat' + 'IsShow'] == 'Y'">{{ item.priceFormat }}</span>
                  <span v-else>
                    <span v-if="printData['salPriceFormat' + 'IsShow'] == 'Y'">{{ item.salPriceFormat }}</span>
                    <span v-if="printData['midPriceFormat' + 'IsShow'] == 'Y'">{{ item.midPriceFormat }}</span>
                    <span v-if="printData['invPriceFormat' + 'IsShow'] == 'Y'">{{ item.invPriceFormat }}</span>
                  </span>
                  <span v-if="['XST', 'XSD'].includes($item.printBillType)">{{ item.totalAmt }}元</span>
                </p>
              </div>
              <div v-else>
                <p class="flex justify_space-between">
                  <span v-if="printData['invQtyFormat' + 'IsShow'] == 'Y'">{{ item.invQtyFormat }}</span>
                  <span v-else>{{ item.billQtyFormat }}</span>
                  <span>{{ item.totalAmt }}元</span>
                </p>
              </div>
              <p v-if="printData['salBarCode' + 'IsShow'] == 'Y' && item.salBarCode">大单位条码：{{ item.salBarCode }}</p>
              <p v-if="printData['midBarCode' + 'IsShow'] == 'Y' && item.midBarCode">中单位条码：{{ item.midBarCode }}</p>
              <p v-if="printData['invBarCode' + 'IsShow'] == 'Y' && item.invBarCode">小单位条码：{{ item.invBarCode }}</p>
              <p class="flex justify_space-between">
                <span>
                  <span v-if="printData['salRetailPrice' + 'IsShow'] == 'Y' || printData['midRetailPrice' + 'IsShow'] == 'Y' || printData['invRetailPrice' + 'IsShow'] == 'Y'">建议零售价：</span>
                  <span v-if="printData['salRetailPrice' + 'IsShow'] == 'Y'">{{ item.salRetailPrice }}</span>
                  <span v-if="printData['midRetailPrice' + 'IsShow'] == 'Y'">{{ item.midRetailPrice }}</span>
                  <span v-if="printData['invRetailPrice' + 'IsShow'] == 'Y'">{{ item.invRetailPrice }}</span>
                </span>
                <span v-if="printData['itemWeight' + 'IsShow'] == 'Y'">重量：{{ item.itemWeight }}</span>
              </p>
              <p class="flex justify_space-between">
                <span v-if="printData['productFactoryName' + 'IsShow'] == 'Y' && item.productFactoryName">生产厂家：{{ item.productFactoryName }}</span>
                <span v-if="printData['itemValid' + 'IsShow'] == 'Y'">保质期：{{ item.itemValid }}</span>
              </p>
              <p v-if="printData['productionDate' + 'IsShow'] == 'Y' && item.productionDate">生产日期：{{ item.productionDate }}</p>
              <p v-if="printData['remark' + 'IsShow'] == 'Y' && item.remark">备注：{{ item.remark }}</p>
              <p class="divider"></p>
            </div>
            <p class="flex justify_space-between">
              <span>总数量：{{ $item.billQtyFormat }}</span>
              <span v-if="['XST', 'XSD'].includes($item.printBillType)">总金额：{{ $item.totalAmt }}元</span>
            </p>
            <p class="flex justify_space-between">
              <span v-if="printData['itemWeightSumFormat' + 'IsShow'] == 'Y' && $item.itemWeightSumFormat">总重量：{{ $item.itemWeightSumFormat }}</span>
              <span v-if="printData['itemWeightAveragePrice' + 'IsShow'] == 'Y' && $item.itemWeightAveragePrice">重量均价：{{ $item.itemWeightAveragePrice }}</span>
            </p>
          </div>
        </div>
        <p class="divider"></p>
        <p class="flex justify_space-between">
          <span>销售：{{ templateHeadData.saleTotalAmt }}元</span>
          <span>退货：{{ templateHeadData.returnTotalAmt }}元</span>
        </p>
        <p class="flex justify_space-between">
          <span>还货：{{ templateHeadData.returnMeetQtyFormat }}</span>
          <span>换货：{{ templateHeadData.exchangeQtyFormat }}</span>
        </p>
        <p class="flex justify_space-between">
          <span>折扣金额：{{ templateHeadData.discountAmt }}</span>
          <span>预收金额：{{ templateHeadData.prePayAmt }}</span>
        </p>
        <p class="flex justify_space-between">
          <span>欠款金额：{{ templateHeadData.arrearAmt }}</span>
          <span>实收金额：{{ templateHeadData.payAmt }}</span>
        </p>

      </div>
      <div v-else-if="type == 'CHD'">
        <p class="center">{{ enterpriseName }}</p>
        <p class="divider"></p>
        <p class="center">单号: {{ templateHeadData.billNo }}</p>
        <p class="center">{{ templateHeadData.customerName }}</p>
        <div class="center dividerBox">
          <p class="divider"></p>
          <span>换货单<span v-if="templateHeadData.billStatus">({{ templateHeadData.billStatus }})</span></span>
        </div>
        <div class="productCard" v-for="(item, index) in templateDetailData" :key="item.id">
          <p>
            <span>{{ index + 1 }}.</span>
            <span>{{ item.itemName }}</span>
            <span>({{ item.itemSpec }})</span>
            <span v-if="item.causeDesc">({{ item.causeDesc }})</span>
          </p>
          <productTemplate :printData="printData" :item="item"></productTemplate>
          <!-- <div v-if="printData['salPriceFormat' + 'IsShow'] == 'Y' || printData['midPriceFormat' + 'IsShow'] == 'Y' || printData['invPriceFormat' + 'IsShow'] == 'Y'">
          <p>
            <span>{{item.billQtyFormat}}</span>
          </p>
          <p class="flex justify_space-between">
            <span>
              <span v-if="printData['salPriceFormat' + 'IsShow'] == 'Y'">{{item.salPriceFormat}}</span>
              <span v-if="printData['midPriceFormat' + 'IsShow'] == 'Y'">{{item.midPriceFormat}}</span>
              <span v-if="printData['invPriceFormat' + 'IsShow'] == 'Y'">{{item.invPriceFormat}}</span>
            </span>
            <span>{{item.totalAmt}}元</span>
          </p>
        </div>
        <div v-else>
          <p class="flex justify_space-between">
            <span>{{item.billQtyFormat}}</span>
            <span>{{item.totalAmt}}元</span>
          </p>
        </div>
        <p v-if="printData['salBarCode' + 'IsShow'] == 'Y' && item.salBarCode">大单位条码：{{item.salBarCode}}</p>
        <p v-if="printData['midBarCode' + 'IsShow'] == 'Y' && item.midBarCode">中单位条码：{{item.midBarCode}}</p>
        <p v-if="printData['invBarCode' + 'IsShow'] == 'Y' && item.invBarCode">小单位条码：{{item.invBarCode}}</p>
        <p class="flex justify_space-between">
          <span>
            <span v-if="printData['salRetailPrice' + 'IsShow'] == 'Y' || printData['midRetailPrice' + 'IsShow'] == 'Y' || printData['invRetailPrice' + 'IsShow'] == 'Y'">建议零售价：</span>
            <span v-if="printData['salRetailPrice' + 'IsShow'] == 'Y'">{{item.salRetailPrice}}</span>
            <span v-if="printData['midRetailPrice' + 'IsShow'] == 'Y'">{{item.midRetailPrice}}</span>
            <span v-if="printData['invRetailPrice' + 'IsShow'] == 'Y'">{{item.invRetailPrice}}</span>
          </span>
          <span v-if="printData['itemWeight' + 'IsShow'] == 'Y'">重量：{{item.itemWeight}}</span>
        </p>
        <p class="flex justify_space-between">
          <span v-if="printData['productFactoryName' + 'IsShow'] == 'Y' && item.productFactoryName">生产厂家：{{item.productFactoryName}}</span>
          <span v-if="printData['itemValid' + 'IsShow'] == 'Y'">保质期：{{item.itemValid}}</span>
        </p> -->
        </div>
        <p class="divider"></p>
        <p>合计：{{ templateHeadData.billQtyFormat }}</p>

      </div>
      <div v-else-if="type == 'CHDD'">
        <p class="center">{{ enterpriseName }}</p>
        <p class="divider"></p>
        <p class="center">单号: {{ templateHeadData.billNo }}</p>
        <p class="center">{{ templateHeadData.customerName }}</p>
        <div class="center dividerBox">
          <p class="divider"></p>
          <span>换货订单<span v-if="templateHeadData.billStatus">({{ templateHeadData.billStatus }})</span></span>
        </div>
        <div class="productCard" v-for="(item, index) in templateDetailData" :key="item.id">
          <p>
            <span>{{ index + 1 }}.</span>
            <span>{{ item.itemName }}</span>
            <span>({{ item.itemSpec }})</span>
            <span v-if="item.causeDesc">({{ item.causeDesc }})</span>
          </p>
          <productTemplate :printData="printData" :item="item"></productTemplate>
          <!-- <div v-if="printData['salPriceFormat' + 'IsShow'] == 'Y' || printData['midPriceFormat' + 'IsShow'] == 'Y' || printData['invPriceFormat' + 'IsShow'] == 'Y'">
          <p>
            <span>{{item.billQtyFormat}}</span>
          </p>
          <p class="flex justify_space-between">
            <span>
              <span v-if="printData['salPriceFormat' + 'IsShow'] == 'Y'">{{item.salPriceFormat}}</span>
              <span v-if="printData['midPriceFormat' + 'IsShow'] == 'Y'">{{item.midPriceFormat}}</span>
              <span v-if="printData['invPriceFormat' + 'IsShow'] == 'Y'">{{item.invPriceFormat}}</span>
            </span>
            <span>{{item.totalAmt}}元</span>
          </p>
        </div>
        <div v-else>
          <p class="flex justify_space-between">
            <span>{{item.billQtyFormat}}</span>
            <span>{{item.totalAmt}}元</span>
          </p>
        </div>
        <p v-if="printData['salBarCode' + 'IsShow'] == 'Y' && item.salBarCode">大单位条码：{{item.salBarCode}}</p>
        <p v-if="printData['midBarCode' + 'IsShow'] == 'Y' && item.midBarCode">中单位条码：{{item.midBarCode}}</p>
        <p v-if="printData['invBarCode' + 'IsShow'] == 'Y' && item.invBarCode">小单位条码：{{item.invBarCode}}</p>
        <p class="flex justify_space-between">
          <span>
            <span v-if="printData['salRetailPrice' + 'IsShow'] == 'Y' || printData['midRetailPrice' + 'IsShow'] == 'Y' || printData['invRetailPrice' + 'IsShow'] == 'Y'">建议零售价：</span>
            <span v-if="printData['salRetailPrice' + 'IsShow'] == 'Y'">{{item.salRetailPrice}}</span>
            <span v-if="printData['midRetailPrice' + 'IsShow'] == 'Y'">{{item.midRetailPrice}}</span>
            <span v-if="printData['invRetailPrice' + 'IsShow'] == 'Y'">{{item.invRetailPrice}}</span>
          </span>
          <span v-if="printData['itemWeight' + 'IsShow'] == 'Y'">重量：{{item.itemWeight}}</span>
        </p>
        <p class="flex justify_space-between">
          <span v-if="printData['productFactoryName' + 'IsShow'] == 'Y' && item.productFactoryName">生产厂家：{{item.productFactoryName}}</span>
          <span v-if="printData['itemValid' + 'IsShow'] == 'Y'">保质期：{{item.itemValid}}</span>
        </p> -->
        </div>
        <p class="divider"></p>
        <p>出库库房：{{ templateHeadData.warehouseName }}</p>

      </div>
      <div v-else-if="type == 'DHD'">
        <p class="center">{{ enterpriseName }}</p>
        <p class="divider"></p>
        <p class="center">单号: {{ templateHeadData.billNo }}</p>
        <p class="center">{{ templateHeadData.customerName }}</p>
        <div class="center dividerBox">
          <p class="divider"></p>
          <span>订货单<span v-if="templateHeadData.billStatus">({{ templateHeadData.billStatus }})</span></span>
        </div>
        <div class="productCard" v-for="(item, index) in templateDetailData" :key="item.id">
          <p>
            <span>{{ index + 1 }}.</span>
            <span>{{ item.itemName }}</span>
            <span>({{ item.itemSpec }})</span>
            <span v-if="item.priceTypeDesc">({{ item.priceTypeDesc }})</span>
            <span v-if="item.salOrderMeetName">({{ item.salOrderMeetName }})</span>
          </p>
          <productTemplate :printData="printData" :item="item"></productTemplate>
          <!-- <div v-if="printData['salPriceFormat' + 'IsShow'] == 'Y' || printData['midPriceFormat' + 'IsShow'] == 'Y' || printData['invPriceFormat' + 'IsShow'] == 'Y'">
          <p>
            <text>{{item.billQtyFormat}}</text>
          </p>
          <p class="flex justify_space-between">
            <span>
              <span v-if="printData['salPriceFormat' + 'IsShow'] == 'Y'">{{item.salPriceFormat}}</span>
              <span v-if="printData['midPriceFormat' + 'IsShow'] == 'Y'">{{item.midPriceFormat}}</span>
              <span v-if="printData['invPriceFormat' + 'IsShow'] == 'Y'">{{item.invPriceFormat}}</span>
            </span>
            <span>{{item.totalAmt}}元</span>
          </p>
        </div>
        <div v-else>
          <p class="flex justify_space-between">
            <span>{{item.billQtyFormat}}</span>
            <span>{{item.totalAmt}}元</span>
          </p>
        </div>
        <p v-if="printData['salBarCode' + 'IsShow'] == 'Y' && item.salBarCode">大单位条码：{{item.salBarCode}}</p>
        <p v-if="printData['midBarCode' + 'IsShow'] == 'Y' && item.midBarCode">中单位条码：{{item.midBarCode}}</p>
        <p v-if="printData['invBarCode' + 'IsShow'] == 'Y' && item.invBarCode">小单位条码：{{item.invBarCode}}</p>
        <p class="flex justify_space-between">
          <span>
            <span v-if="printData['salRetailPrice' + 'IsShow'] == 'Y' || printData['midRetailPrice' + 'IsShow'] == 'Y' || printData['invRetailPrice' + 'IsShow'] == 'Y'">建议零售价：</span>
            <span v-if="printData['salRetailPrice' + 'IsShow'] == 'Y'">{{item.salRetailPrice}}</span>
            <span v-if="printData['midRetailPrice' + 'IsShow'] == 'Y'">{{item.midRetailPrice}}</span>
            <span v-if="printData['invRetailPrice' + 'IsShow'] == 'Y'">{{item.invRetailPrice}}</span>
          </span>
          <span v-if="printData['itemWeight' + 'IsShow'] == 'Y'">重量：{{item.itemWeight}}</span>
        </p>
        <p class="flex justify_space-between">
          <span v-if="printData['productFactoryName' + 'IsShow'] == 'Y' && item.productFactoryName">生产厂家：{{item.productFactoryName}}</span>
          <span v-if="printData['itemValid' + 'IsShow'] == 'Y'">保质期：{{item.itemValid}}</span>
        </p> -->
        </div>
        <p class="divider"></p>
        <p>实收金额：{{ templateHeadData.payAmt }}</p>
        <p class="flex justify_space-between">
          <span>订货总价：{{ templateHeadData.totalAmt }}元</span>
          <span>折扣金额：{{ templateHeadData.discountAmt }}元</span>
        </p>
        <p class="flex justify_space-between">
          <span>冲抵预收：{{ templateHeadData.prePayAmt }}元</span>
          <span>新增欠款：{{ templateHeadData.arrearAmt }}元</span>
        </p>
        <p>交易账户：{{ templateHeadData.accountName }}</p>

      </div>
      <div v-else-if="type == 'PKD'">
        <p class="center">{{ enterpriseName }}</p>
        <p class="divider"></p>
        <p class="center">单号: {{ templateHeadData.billNo }}</p>
        <div class="center dividerBox">
          <p class="divider"></p>
          <span>{{ templateHeadData.title }}<span v-if="templateHeadData.billStatus">({{ templateHeadData.billStatus }})</span></span>
        </div>
        <div class="productCard" v-for="(item, index) in templateDetailData" :key="item.id">
          <p>
            <span>{{ index + 1 }}.</span>
            <span>{{ item.itemName }}</span>
            <span>({{ item.itemSpec }})</span>
          </p>
          <p class="flex justify_space-between">
            <span>
              数量：
              <span v-if="printData['invQtyFormat' + 'IsShow'] == 'Y'">{{ item.invQtyFormat }}</span>
              <span v-else>{{ item.billQtyFormat }}</span>
            </span>
            <span v-if="printData['invCheckAmtFormat' + 'IsShow'] == 'Y'">{{ item.invCheckAmtFormat }}</span>
          </p>
          <p class="flex justify_space-between">
            <span>库存数量：{{ item.onhandQtyFormat }}</span>
          </p>
          <p v-if="printData['salBarCode' + 'IsShow'] == 'Y' && item.salBarCode">大单位条码：{{ item.salBarCode }}</p>
          <p v-if="printData['midBarCode' + 'IsShow'] == 'Y' && item.midBarCode">中单位条码：{{ item.midBarCode }}</p>
          <p v-if="printData['invBarCode' + 'IsShow'] == 'Y' && item.invBarCode">小单位条码：{{ item.invBarCode }}</p>
          <p v-if="printData['productionDate' + 'IsShow'] == 'Y' && item.productionDate">生产日期：{{ item.productionDate }}</p>
          <p v-if="printData['remark' + 'IsShow'] == 'Y' && item.remark">备注：{{ item.remark }}</p>
        </div>
        <p class="divider"></p>
        <p>盘点库房：{{ templateHeadData.warehouseName }}</p>
        <p>业务员：{{ templateHeadData.salesmanName }}</p>
        <p>录入日期：{{ templateHeadData.billDate }}</p>
        <p v-if="printData['billRemark' + 'IsShow'] == 'Y'">整单备注：{{ templateHeadData.billRemark }}</p>
        <p v-if="printData['totalAmt' + 'IsShow'] == 'Y'">调整总金额：{{ templateHeadData.totalAmt }}元</p>
      </div>
      <div v-else-if="type == 'DXDH'">
        <p class="center">{{ enterpriseName }}</p>
        <div v-for="(item, index) in templateDetailData" :key="index">
          <p class="center">{{ item.customerName }}</p>
          <div class="center dividerBox">
            <p class="divider"></p>
            <span>{{ item.title }}</span>
          </div>
          <p>业务员：{{ item.salesmanName }}</p>
          <p>进店时间：{{ item.inDateTime }}</p>
          <p>离店时间：{{ item.outDateTime }}</p>
          <p>停留时间：{{ item.stayDateTime }}</p>
          <p class="flex justify_space-between">
            <span>销售总价：{{ item.salTotalAmt }}元</span>
            <span>退货总价：{{ item.salReturnTotalAmt }}元</span>
          </p>
          <p class="flex justify_space-between">
            <span>现金费用：{{ item.feeCashAmt }}元</span>
            <span>订货总额：{{ item.meetTotalAmt }}元</span>
          </p>
          <p class="flex justify_space-between">
            <span>还货数量：{{ item.returnMeetQtyFormat }}</span>
            <span>换货数量：{{ item.exchangeQtyFormat }}</span>
          </p>
          <p class="flex justify_space-between">
            <span>应上交金额：{{ item.needHandPay }}元</span>
            <span>收款总额：{{ item.payTotalAmt }}元</span>
          </p>
          <!-- <p>总金额：{{item.totalAmt}}</p> -->
          <p class="flex justify_space-between">
            <span v-if="printData['arrearAmt' + 'IsShow'] == 'Y'">欠款余额：{{ item.arrearAmt }}元</span>
            <span v-if="printData['prePayAmt' + 'IsShow'] == 'Y'">预收款余额：{{ item.prePayAmt }}元</span>
          </p>
          <p class="flex justify_space-between">
            <span v-if="printData['offsetDistance' + 'IsShow'] == 'Y'">偏差距离：{{ item.offsetDistance }}</span>
            <span v-if="printData['isdeal' + 'IsShow'] == 'Y'">是否达成：{{ item.isdeal }}</span>
          </p>
        </div>

      </div>
      <div v-else-if="type == 'DXD'">
        <p class="center">{{ enterpriseName }}</p>
        <div class="center dividerBox">
            <p class="divider"></p>
            <span>{{ templateHeadData.title }}</span>
          </div>
        <p class="flex justify_space-between">
          <span>拜访人：{{ templateHeadData.salesmanName }}</span>
          <span>库房：{{ templateHeadData.warehouseName }}</span>
        </p>
        <p>门店：{{ templateHeadData.customerName }}</p>
        <p>进店时间：{{ templateHeadData.inDateTime }}</p>
        <p>离店时间：{{ templateHeadData.outDateTime }}</p>
        <p>停留时间：{{ templateHeadData.stayDateTime }}</p>
        <div v-for="($item, $index) in templateDetailData" :key="$index">
          <div class="center dividerBox">
            <p class="divider"></p>
            <span>{{ $item.title }}</span>
          </div>
          <div v-if="$item.printItemDetailModels">
            <div class="productCard" v-for="(item, index) in $item.printItemDetailModels" :key="index">
              <p>
                <span>{{ index + 1 }}.</span>
                <span>{{ item.itemName }}</span>
                <span>({{ item.itemSpec }})</span>
                <span v-if="item.priceTypeDesc">({{ item.priceTypeDesc }})</span>
                <span v-if="item.causeDesc && ['XST', 'XTY', 'CHD', 'CHDD'].includes($item.printBillType)">({{ item.causeDesc }})</span>
                <span v-if="item.salOrderMeetName && ['HHD', 'DHD', 'CXD', 'HDD'].includes($item.printBillType)">({{ item.salOrderMeetName }})</span>
              </p>
              <productTemplate :printData="printData" :item="item"></productTemplate>
              <!-- <div v-if="printData['salPriceFormat' + 'IsShow'] == 'Y' || printData['midPriceFormat' + 'IsShow'] == 'Y' || printData['invPriceFormat' + 'IsShow'] == 'Y'">
              <p>
                <span>{{item.billQtyFormat}}</span>
              </p>
              <p class="flex justify_space-between">
                <span>
                  <span v-if="printData['salPriceFormat' + 'IsShow'] == 'Y'">{{item.salPriceFormat}}</span>
                  <span v-if="printData['midPriceFormat' + 'IsShow'] == 'Y'">{{item.midPriceFormat}}</span>
                  <span v-if="printData['invPriceFormat' + 'IsShow'] == 'Y'">{{item.invPriceFormat}}</span>
                </span>
                <span>{{item.totalAmt}}元</span>
              </p>
            </div>
            <div v-else>
              <p class="flex justify_space-between">
                <span>{{item.billQtyFormat}}</span>
                <span>{{item.totalAmt}}元</span>
              </p>
            </div>
            <p v-if="printData['salBarCode' + 'IsShow'] == 'Y' && item.salBarCode">大单位条码：{{item.salBarCode}}</p>
            <p v-if="printData['midBarCode' + 'IsShow'] == 'Y' && item.midBarCode">中单位条码：{{item.midBarCode}}</p>
            <p v-if="printData['invBarCode' + 'IsShow'] == 'Y' && item.invBarCode">小单位条码：{{item.invBarCode}}</p>
            <p class="flex justify_space-between">
              <span>
                <span v-if="printData['salRetailPrice' + 'IsShow'] == 'Y' || printData['midRetailPrice' + 'IsShow'] == 'Y' || printData['invRetailPrice' + 'IsShow'] == 'Y'">建议零售价：</span>
                <span v-if="printData['salRetailPrice' + 'IsShow'] == 'Y'">{{item.salRetailPrice}}</span>
                <span v-if="printData['midRetailPrice' + 'IsShow'] == 'Y'">{{item.midRetailPrice}}</span>
                <span v-if="printData['invRetailPrice' + 'IsShow'] == 'Y'">{{item.invRetailPrice}}</span>
              </span>
              <span v-if="printData['itemWeight' + 'IsShow'] == 'Y'">重量：{{item.itemWeight}}</span>
            </p>
            <p class="flex justify_space-between">
              <span v-if="printData['productFactoryName' + 'IsShow'] == 'Y' && item.productFactoryName">生产厂家：{{item.productFactoryName}}</span>
              <span v-if="printData['itemValid' + 'IsShow'] == 'Y'">保质期：{{item.itemValid}}</span>
            </p> -->
              <p class="divider"></p>
            </div>
            <p class="flex justify_space-between">
              <span>总数量：{{ $item.billQtyFormat }}</span>
              <span v-if="!['HHD', 'HDD', 'CHD', 'CHDD'].includes($item.printBillType)">总金额：{{ $item.totalAmt }}元</span>
            </p>
            <p v-if="printData['billRemark' + 'IsShow'] == 'Y' && $item.billRemark">整单备注：{{ $item.billRemark }}</p>
          </div>
        </div>
        <p class="divider"></p>
        <p class="flex justify_space-between">
          <span>销售：{{ templateHeadData.saleTotalAmt }}元</span>
          <span>退货：{{ templateHeadData.returnTotalAmt }}元</span>
        </p>
        <p class="flex justify_space-between">
          <span>还货：{{ templateHeadData.returnMeetQtyFormat }}</span>
          <span>换货：{{ templateHeadData.exchangeQtyFormat }}</span>
        </p>
        <p class="flex justify_space-between">
          <span>折扣金额：{{ templateHeadData.discountAmt }}</span>
          <span>预收金额：{{ templateHeadData.prePayAmt }}</span>
        </p>
        <p class="flex justify_space-between">
          <span>欠款变化：{{ templateHeadData.arrearAmt }}</span>
          <span>实收变化：{{ templateHeadData.payAmt }}</span>
        </p>
        <p class="flex justify_space-between">
          <span v-if="printData['boss' + 'IsShow'] == 'Y'">监督人：{{ templateHeadData.boss }}</span>
          <span v-if="printData['bossPhone' + 'IsShow'] == 'Y'">监督电话：{{ templateHeadData.bossPhone }}</span>
        </p>
        <p class="flex justify_space-between">
          <span v-if="printData['salesmanPhone' + 'IsShow'] == 'Y'">业务电话：{{ templateHeadData.salesmanPhone }}</span>
          <span v-if="printData['signer' + 'IsShow'] == 'Y'">签收人：__________</span>
        </p>
      </div>
      <div v-else-if="type == 'CGD'">
        <p class="center">{{ enterpriseName }}</p>
        <p class="divider"></p>
        <p class="center">单号: {{ templateHeadData.billNo }}</p>
        <p class="center">{{ templateHeadData.customerName }}</p>
        <div class="center dividerBox">
          <p class="divider"></p>
          <span>采购进货单<span v-if="templateHeadData.billStatus">({{ templateHeadData.billStatus }})</span></span>
        </div>
        <div class="productCard" v-for="(item, index) in templateDetailData" :key="item.id">
          <p>
            <span>{{ index + 1 }}.</span>
            <span>{{ item.itemName }}</span>
            <span>({{ item.itemSpec }})</span>
            <span v-if="item.priceTypeDesc">({{ item.priceTypeDesc }})</span>
          </p>
          <!-- <div v-if="printData['salPriceFormat' + 'IsShow'] == 'Y' || printData['midPriceFormat' + 'IsShow'] == 'Y' || printData['invPriceFormat' + 'IsShow'] == 'Y'">
          <p>
            <span>{{item.billQtyFormat}}</span>
          </p>
          <p class="flex justify_space-between">
            <span>
              <span v-if="printData['salPriceFormat' + 'IsShow'] == 'Y'">{{item.salPriceFormat}}</span>
              <span v-if="printData['midPriceFormat' + 'IsShow'] == 'Y'">{{item.midPriceFormat}}</span>
              <span v-if="printData['invPriceFormat' + 'IsShow'] == 'Y'">{{item.invPriceFormat}}</span>
            </span>
            <span>{{item.totalAmt}}元</span>
          </p>
        </div>
        <div v-else>
          <p class="flex justify_space-between">
            <span>{{item.billQtyFormat}}</span>
            <span>{{item.totalAmt}}元</span>
          </p>
        </div>
        <p v-if="printData['salBarCode' + 'IsShow'] == 'Y' && item.salBarCode">大单位条码：{{item.salBarCode}}</p>
        <p v-if="printData['midBarCode' + 'IsShow'] == 'Y' && item.midBarCode">中单位条码：{{item.midBarCode}}</p>
        <p v-if="printData['invBarCode' + 'IsShow'] == 'Y' && item.invBarCode">小单位条码：{{item.invBarCode}}</p>
        <p class="flex justify_space-between">
          <span>
            <span v-if="printData['salRetailPrice' + 'IsShow'] == 'Y' || printData['midRetailPrice' + 'IsShow'] == 'Y' || printData['invRetailPrice' + 'IsShow'] == 'Y'">建议零售价：</span>
            <span v-if="printData['salRetailPrice' + 'IsShow'] == 'Y'">{{item.salRetailPrice}}</span>
            <span v-if="printData['midRetailPrice' + 'IsShow'] == 'Y'">{{item.midRetailPrice}}</span>
            <span v-if="printData['invRetailPrice' + 'IsShow'] == 'Y'">{{item.invRetailPrice}}</span>
          </span>
          <span v-if="printData['itemWeight' + 'IsShow'] == 'Y'">重量：{{item.itemWeight}}</span>
        </p>
        <p class="flex justify_space-between">
          <span v-if="printData['productFactoryName' + 'IsShow'] == 'Y' && item.productFactoryName">生产厂家：{{item.productFactoryName}}</span>
          <span v-if="printData['itemValid' + 'IsShow'] == 'Y'">保质期：{{item.itemValid}}</span>
        </p> -->
          <productTemplate :printData="printData" :item="item"></productTemplate>
        </div>
        <p class="divider"></p>
        <p>供应商：{{ templateHeadData.customerName }}</p>
        <p class="flex justify_space-between">
          <span>入库库房：{{ templateHeadData.warehouseName }}</span>
          <span>业务员：{{ templateHeadData.salesmanName }}</span>
        </p>
        <p class="flex justify_space-between">
          <span>采购金额：{{ templateHeadData.totalAmt }}元</span>
          <span>实付金额：{{ templateHeadData.payAmt }}元</span>
        </p>
        <p class="flex justify_space-between">
          <span>兑奖券金额：{{ templateHeadData.prizeAmt }}元</span>
          <span>折扣金额：{{ templateHeadData.discountAmt }}元</span>
        </p>
        <p class="flex justify_space-between">
          <span>冲抵预收：{{ templateHeadData.prePayAmt }}元</span>
          <span>新增欠款：{{ templateHeadData.arrearAmt }}元</span>
        </p>
        <p class="flex justify_space-between">
          <span>交易账户：{{ templateHeadData.accountName }}</span>
          <span>收款方式：{{ templateHeadData.payMethod }}</span>
        </p>
        <p>备注：{{ templateHeadData.remark }}</p>
        <p>单据时间：{{ templateHeadData.billDate }}</p>
      </div>
      <div v-else-if="type == 'CGT'">
        <p class="center">{{ enterpriseName }}</p>
        <p class="divider"></p>
        <p class="center">单号: {{ templateHeadData.billNo }}</p>
        <p class="center">{{ templateHeadData.customerName }}</p>
        <div class="center dividerBox">
          <p class="divider"></p>
          <span>采购退货单<span v-if="templateHeadData.billStatus">({{ templateHeadData.billStatus }})</span></span>
        </div>
        <div class="productCard" v-for="(item, index) in templateDetailData" :key="item.id">
          <p>
            <span>{{ index + 1 }}.</span>
            <span>{{ item.itemName }}</span>
            <span>({{ item.itemSpec }})</span>
            <span v-if="item.priceTypeDesc">({{ item.priceTypeDesc }})</span>
            <span v-if="item.causeDesc">({{ item.causeDesc }})</span>
          </p>
          <!-- <div v-if="printData['salPriceFormat' + 'IsShow'] == 'Y' || printData['midPriceFormat' + 'IsShow'] == 'Y' || printData['invPriceFormat' + 'IsShow'] == 'Y'">
          <p>
            <span>{{item.billQtyFormat}}</span>
          </p>
          <p class="flex justify_space-between">
            <span>
              <span v-if="printData['salPriceFormat' + 'IsShow'] == 'Y'">{{item.salPriceFormat}}</span>
              <span v-if="printData['midPriceFormat' + 'IsShow'] == 'Y'">{{item.midPriceFormat}}</span>
              <span v-if="printData['invPriceFormat' + 'IsShow'] == 'Y'">{{item.invPriceFormat}}</span>
            </span>
            <span>{{item.totalAmt}}元</span>
          </p>
        </div>
        <div v-else>
          <p class="flex justify_space-between">
            <span>{{item.billQtyFormat}}</span>
            <span>{{item.totalAmt}}元</span>
          </p>
        </div>
        <p v-if="printData['salBarCode' + 'IsShow'] == 'Y' && item.salBarCode">大单位条码：{{item.salBarCode}}</p>
        <p v-if="printData['midBarCode' + 'IsShow'] == 'Y' && item.midBarCode">中单位条码：{{item.midBarCode}}</p>
        <p v-if="printData['invBarCode' + 'IsShow'] == 'Y' && item.invBarCode">小单位条码：{{item.invBarCode}}</p>
        <p class="flex justify_space-between">
          <span>
            <span v-if="printData['salRetailPrice' + 'IsShow'] == 'Y' || printData['midRetailPrice' + 'IsShow'] == 'Y' || printData['invRetailPrice' + 'IsShow'] == 'Y'">建议零售价：</span>
            <span v-if="printData['salRetailPrice' + 'IsShow'] == 'Y'">{{item.salRetailPrice}}</span>
            <span v-if="printData['midRetailPrice' + 'IsShow'] == 'Y'">{{item.midRetailPrice}}</span>
            <span v-if="printData['invRetailPrice' + 'IsShow'] == 'Y'">{{item.invRetailPrice}}</span>
          </span>
          <span v-if="printData['itemWeight' + 'IsShow'] == 'Y'">重量：{{item.itemWeight}}</span>
        </p>
        <p class="flex justify_space-between">
          <span v-if="printData['productFactoryName' + 'IsShow'] == 'Y' && item.productFactoryName">生产厂家：{{item.productFactoryName}}</span>
          <span v-if="printData['itemValid' + 'IsShow'] == 'Y'">保质期：{{item.itemValid}}</span>
        </p> -->
          <productTemplate :printData="printData" :item="item"></productTemplate>
        </div>
        <p class="divider"></p>
        <p>供应商：{{ templateHeadData.customerName }}</p>
        <p class="flex justify_space-between">
          <span>出库库房：{{ templateHeadData.warehouseName }}</span>
          <span>业务员：{{ templateHeadData.salesmanName }}</span>
        </p>
        <p class="flex justify_space-between">
          <span>采购金额：{{ templateHeadData.totalAmt }}元</span>
          <span>实付金额：{{ templateHeadData.payAmt }}元</span>
        </p>
        <p class="flex justify_space-between">
          <span>兑奖券金额：{{ templateHeadData.prizeAmt }}元</span>
          <span>折扣金额：{{ templateHeadData.discountAmt }}元</span>
        </p>
        <p class="flex justify_space-between">
          <span>冲抵预收：{{ templateHeadData.prePayAmt }}元</span>
          <span>新增欠款：{{ templateHeadData.arrearAmt }}元</span>
        </p>
        <p class="flex justify_space-between">
          <span>交易账户：{{ templateHeadData.accountName }}</span>
          <span>收款方式：{{ templateHeadData.payMethod }}</span>
        </p>
        <p>备注：{{ templateHeadData.remark }}</p>
        <p v-if="printData['returnOrderBillNo' + 'IsShow'] == 'Y' && templateHeadData.returnOrderBillNo">退货单号：{{ templateHeadData.returnOrderBillNo }}</p>
        <p>单据时间：{{ templateHeadData.billDate }}</p>
      </div>
      <div v-else-if="type == 'XSIHZ'">
        <p class="center">{{ enterpriseName }}</p>
        <div class="center dividerBox">
          <p class="divider"></p>
          <span>销售汇总</span>
        </div>
        <div class="productCard" v-for="(item, index) in templateDetailData" :key="item.id">
          <div>
            <span>{{ index + 1 }}.</span>
            <span>{{ item.itemName }}</span>
          </div>
          <div>{{ item.salType }}</div>
          <div>{{ item.returnType }}</div>
          <div>{{ item.returnMeetType }}</div>
          <div class="divider"></div>
        </div>
        <div class="flex justify_space-between">
          <!--单品种类：-->
          <text>{{ templateHeadData.itemKind }}</text>
          <!--销售数量-->
          <text>{{ templateHeadData.saleSum }}</text>
        </div>
        <div class="flex justify_space-between">
          <!--退货数量-->
          <text>{{ templateHeadData.returnSum }}</text>
          <!--还货数量-->
          <text>{{ templateHeadData.saleBackSum }}</text>
        </div>
        <!--      <div>备注：{{templateHeadData.remark}}</div>-->
        <div>汇总时间：{{ templateHeadData.startDate }} - {{ templateHeadData.endDate }}</div>
      </div>
      <div v-else-if="type == 'CGDD'">
        <p class="center">{{ enterpriseName }}</p>
        <p class="divider"></p>
        <p class="center">单号: {{ templateHeadData.billNo }}</p>
        <p class="center">{{ templateHeadData.customerName }}</p>
        <div class="center dividerBox">
          <p class="divider"></p>
          <span>采购订单<span v-if="templateHeadData.billStatus">({{ templateHeadData.billStatus }})</span></span>
        </div>
        <div class="productCard" v-for="(item, index) in templateDetailData" :key="item.id">
          <p>
            <span>{{ index + 1 }}.</span>
            <span>{{ item.itemName }}</span>
            <span>({{ item.itemSpec }})</span>
            <span v-if="item.priceTypeDesc">({{ item.priceTypeDesc }})</span>
          </p>
          <!-- <div v-if="printData['salPriceFormat' + 'IsShow'] == 'Y' || printData['midPriceFormat' + 'IsShow'] == 'Y' || printData['invPriceFormat' + 'IsShow'] == 'Y'">
          <p>
            <span>{{item.billQtyFormat}}</span>
          </p>
          <p class="flex justify_space-between">
            <span>
              <span v-if="printData['salPriceFormat' + 'IsShow'] == 'Y'">{{item.salPriceFormat}}</span>
              <span v-if="printData['midPriceFormat' + 'IsShow'] == 'Y'">{{item.midPriceFormat}}</span>
              <span v-if="printData['invPriceFormat' + 'IsShow'] == 'Y'">{{item.invPriceFormat}}</span>
            </span>
            <span>{{item.totalAmt}}元</span>
          </p>
        </div>
        <div v-else>
          <p class="flex justify_space-between">
            <span>{{item.billQtyFormat}}</span>
            <span>{{item.totalAmt}}元</span>
          </p>
        </div>
        <p v-if="printData['salBarCode' + 'IsShow'] == 'Y' && item.salBarCode">大单位条码：{{item.salBarCode}}</p>
        <p v-if="printData['midBarCode' + 'IsShow'] == 'Y' && item.midBarCode">中单位条码：{{item.midBarCode}}</p>
        <p v-if="printData['invBarCode' + 'IsShow'] == 'Y' && item.invBarCode">小单位条码：{{item.invBarCode}}</p>
        <p class="flex justify_space-between">
          <span>
            <span v-if="printData['salRetailPrice' + 'IsShow'] == 'Y' || printData['midRetailPrice' + 'IsShow'] == 'Y' || printData['invRetailPrice' + 'IsShow'] == 'Y'">建议零售价：</span>
            <span v-if="printData['salRetailPrice' + 'IsShow'] == 'Y'">{{item.salRetailPrice}}</span>
            <span v-if="printData['midRetailPrice' + 'IsShow'] == 'Y'">{{item.midRetailPrice}}</span>
            <span v-if="printData['invRetailPrice' + 'IsShow'] == 'Y'">{{item.invRetailPrice}}</span>
          </span>
          <span v-if="printData['itemWeight' + 'IsShow'] == 'Y'">重量：{{item.itemWeight}}</span>
        </p>
        <p class="flex justify_space-between">
          <span v-if="printData['productFactoryName' + 'IsShow'] == 'Y' && item.productFactoryName">生产厂家：{{item.productFactoryName}}</span>
          <span v-if="printData['itemValid' + 'IsShow'] == 'Y'">保质期：{{item.itemValid}}</span>
        </p> -->
          <productTemplate :printData="printData" :item="item"></productTemplate>
        </div>
        <p class="divider"></p>
        <p>供应商：{{ templateHeadData.customerName }}</p>
        <p class="flex justify_space-between">
          <span>入库库房：{{ templateHeadData.warehouseName }}</span>
          <span>业务员：{{ templateHeadData.salesmanName }}</span>
        </p>
        <p class="flex justify_space-between">
          <span>采购金额：{{ templateHeadData.totalAmt }}元</span>
          <span>实付金额：{{ templateHeadData.payAmt }}元</span>
        </p>
        <p class="flex justify_space-between">
          <!-- <span>兑奖券金额：{{ templateHeadData.prizeAmt }}元</span> -->
          <span>折扣金额：{{ templateHeadData.discountAmt }}元</span>
        </p>
        <p class="flex justify_space-between">
          <span>冲抵预收：{{ templateHeadData.prePayAmt }}元</span>
          <span>新增欠款：{{ templateHeadData.arrearAmt }}元</span>
        </p>
        <p class="flex justify_space-between">
          <span>交易账户：{{ templateHeadData.accountName }}</span>
          <span>收款方式：{{ templateHeadData.payMethod }}</span>
        </p>
        <p>备注：{{ templateHeadData.remark }}</p>
        <p>单据时间：{{ templateHeadData.billDate }}</p>
      </div>
      <div v-else-if="type == 'CGTD'">
        <p class="center">{{ enterpriseName }}</p>
        <p class="divider"></p>
        <p class="center">单号: {{ templateHeadData.billNo }}</p>
        <p class="center">{{ templateHeadData.customerName }}</p>
        <div class="center dividerBox">
          <p class="divider"></p>
          <span>采购退货订单<span v-if="templateHeadData.billStatus">({{ templateHeadData.billStatus }})</span></span>
        </div>
        <div class="productCard" v-for="(item, index) in templateDetailData" :key="item.id">
          <p>
            <span>{{ index + 1 }}.</span>
            <span>{{ item.itemName }}</span>
            <span>({{ item.itemSpec }})</span>
            <span v-if="item.priceTypeDesc">({{ item.priceTypeDesc }})</span>
            <span v-if="item.causeDesc">({{ item.causeDesc }})</span>
          </p>
          <!-- <div v-if="printData['salPriceFormat' + 'IsShow'] == 'Y' || printData['midPriceFormat' + 'IsShow'] == 'Y' || printData['invPriceFormat' + 'IsShow'] == 'Y'">
          <p>
            <span>{{item.billQtyFormat}}</span>
          </p>
          <p class="flex justify_space-between">
            <span>
              <span v-if="printData['salPriceFormat' + 'IsShow'] == 'Y'">{{item.salPriceFormat}}</span>
              <span v-if="printData['midPriceFormat' + 'IsShow'] == 'Y'">{{item.midPriceFormat}}</span>
              <span v-if="printData['invPriceFormat' + 'IsShow'] == 'Y'">{{item.invPriceFormat}}</span>
            </span>
            <span>{{item.totalAmt}}元</span>
          </p>
        </div>
        <div v-else>
          <p class="flex justify_space-between">
            <span>{{item.billQtyFormat}}</span>
            <span>{{item.totalAmt}}元</span>
          </p>
        </div>
        <p v-if="printData['salBarCode' + 'IsShow'] == 'Y' && item.salBarCode">大单位条码：{{item.salBarCode}}</p>
        <p v-if="printData['midBarCode' + 'IsShow'] == 'Y' && item.midBarCode">中单位条码：{{item.midBarCode}}</p>
        <p v-if="printData['invBarCode' + 'IsShow'] == 'Y' && item.invBarCode">小单位条码：{{item.invBarCode}}</p>
        <p class="flex justify_space-between">
          <span>
            <span v-if="printData['salRetailPrice' + 'IsShow'] == 'Y' || printData['midRetailPrice' + 'IsShow'] == 'Y' || printData['invRetailPrice' + 'IsShow'] == 'Y'">建议零售价：</span>
            <span v-if="printData['salRetailPrice' + 'IsShow'] == 'Y'">{{item.salRetailPrice}}</span>
            <span v-if="printData['midRetailPrice' + 'IsShow'] == 'Y'">{{item.midRetailPrice}}</span>
            <span v-if="printData['invRetailPrice' + 'IsShow'] == 'Y'">{{item.invRetailPrice}}</span>
          </span>
          <span v-if="printData['itemWeight' + 'IsShow'] == 'Y'">重量：{{item.itemWeight}}</span>
        </p>
        <p class="flex justify_space-between">
          <span v-if="printData['productFactoryName' + 'IsShow'] == 'Y' && item.productFactoryName">生产厂家：{{item.productFactoryName}}</span>
          <span v-if="printData['itemValid' + 'IsShow'] == 'Y'">保质期：{{item.itemValid}}</span>
        </p> -->
          <productTemplate :printData="printData" :item="item"></productTemplate>
        </div>
        <p class="divider"></p>
        <p>供应商：{{ templateHeadData.customerName }}</p>
        <p class="flex justify_space-between">
          <span>出库库房：{{ templateHeadData.warehouseName }}</span>
          <span>业务员：{{ templateHeadData.salesmanName }}</span>
        </p>
        <p class="flex justify_space-between">
          <span>采购金额：{{ templateHeadData.totalAmt }}元</span>
          <span>实收金额：{{ templateHeadData.payAmt }}元</span>
        </p>
        <p class="flex justify_space-between">
          <!-- <span>兑奖券金额：{{ templateHeadData.prizeAmt }}元</span> -->
          <span>折扣金额：{{ templateHeadData.discountAmt }}元</span>
        </p>
        <p class="flex justify_space-between">
          <span>预收金额：{{ templateHeadData.prePayAmt }}元</span>
          <span>欠款金额：{{ templateHeadData.arrearAmt }}元</span>
        </p>
        <p class="flex justify_space-between">
          <span>交易账户：{{ templateHeadData.accountName }}</span>
          <span>收款方式：{{ templateHeadData.payMethod }}</span>
        </p>
        <p>备注：{{ templateHeadData.remark }}</p>
        <p v-if="printData['returnOrderBillNo' + 'IsShow'] == 'Y' && templateHeadData.returnOrderBillNo">退货单号：{{ templateHeadData.returnOrderBillNo }}</p>
        <p>单据时间：{{ templateHeadData.billDate }}</p>
      </div>
      <div v-if="['XSD', 'XSY', 'XST', 'XTY', 'HHD', 'HDD', 'CXD', 'CHD', 'CHDD', 'DHD'].includes(type)">
        <p v-if="type != 'CXD' && printData['billQtySumFormat' + 'IsShow'] == 'Y'">总数量：{{ templateDetailData[0] && templateDetailData[0].billQtySumFormat }}</p>
        <p class="flex justify_space-between" v-if="type != 'CXD'">
          <span v-if="printData['itemWeightSumFormat' + 'IsShow'] == 'Y'">总重量：{{ templateDetailData[0] && templateDetailData[0].itemWeightSumFormat }}</span>
          <span v-if="printData['itemWeightAveragePrice' + 'IsShow'] == 'Y'">重量均价：{{ templateDetailData[0] && templateDetailData[0].itemWeightAveragePrice }}</span>
        </p>
        <p class="flex justify_space-between">
          <span v-if="printData['boss' + 'IsShow'] == 'Y'">监督人：{{ templateHeadData.boss }}</span>
          <span v-if="printData['bossPhone' + 'IsShow'] == 'Y'">监督电话：{{ templateHeadData.bossPhone }}</span>
        </p>
        <p class="flex justify_space-between">
          <span v-if="printData['salesmanPhone' + 'IsShow'] == 'Y'">业务电话：{{ templateHeadData.salesmanPhone }}</span>
          <span v-if="printData['signer' + 'IsShow'] == 'Y'">签收人：__________</span>
        </p>
        <p>单据时间：{{ templateHeadData.billDate }}</p>
      </div>
      <div>
        <p v-if="printData['billRemark' + 'IsShow'] == 'Y' && templateHeadData.billRemark">整单备注：{{ templateHeadData.billRemark }}</p>
        <p class="divider"></p>
        <p>{{ remark }}</p>
      </div>
    </div>
    <div v-if="version == 2">
      <template v-if="isMultilayer">
        <div v-for="item in printShowModel" :key="item.id">
          <div v-if="item.type === 'text'"
            :style="`text-align: ${item.float === 1 ? 'center' : (item.float === 2 ? 'right' : 'left')};`">
            {{ replaceVariables(item, templateHeadData, printData) }}
          </div>
          <div v-if="item.type === 'oneLineText'"
            :style="`text-align: ${item.float === 1 ? 'center' : (item.float === 2 ? 'right' : 'left')};`">
            <span v-for="(subItem, subIndex) in item.value" :key="subIndex">{{ replaceVariables(subItem, templateHeadData, printData) }}</span>
          </div>
          <div v-else-if="item.type === 'dividerConter'"
            :style="`text-align: ${item.float === 1 ? 'center' : (item.float === 2 ? 'right' : 'left')};`"
            class="dividerBox">
            <p class="divider"></p>
            <span>{{ replaceVariables(item, templateHeadData, printData) }}</span>
          </div>
          <div v-else-if="item.type === 'divider'">
            <p class="divider"></p>
          </div>
          <div v-else-if="item.type === 'textarea'" style="display: flex; justify-content: space-between;">
            <span v-for="(subItem, subIndex) in item.value" :key="subIndex">{{ replaceVariables(subItem, templateHeadData, printData) }}</span>
          </div>
          <div v-else-if="item.type === 'loop'">
            <template v-if="item.valueType == 'Array'">
              <template v-for="(loop, loopIndex) in item.value" >
                <multilayerModelTemplate v-if="(!loop.show || (loop.show && printData[loop.show + 'IsShow'] == 'Y')) && (!loop.hide || loop.hide && printData[loop.hide + 'IsShow'] != 'Y')" :key="loopIndex" :printData="printData" :source="[templateDetailData[loopIndex]]" :model="loop.model"></multilayerModelTemplate>
              </template>
            </template>
            <template v-else-if="item.valueType == 'Object'">
              <template v-for="(loop, loopIndex) in templateDetailData" >
                <multilayerModelTemplate v-if="item.value[loop[item.valueKey]] && (!item.value[loop[item.valueKey]].show || (item.value[loop[item.valueKey]].show && printData[item.value[loop[item.valueKey]].show + 'IsShow'] == 'Y')) && (!item.value[loop[item.valueKey]].hide || item.value[loop[item.valueKey]].hide && printData[item.value[loop[item.valueKey]].hide + 'IsShow'] != 'Y')" :key="loopIndex" :printData="printData" :source="[loop]" :model="item.value[loop[item.valueKey]].model"></multilayerModelTemplate>
              </template>
            </template>
            <template v-else>
              <multilayerModelTemplate :printData="printData" :source="templateDetailData" :model="item.value.model" v-if="(!item.value.show || (item.value.show && printData[item.value.show + 'IsShow'] == 'Y')) && (!item.value.hide || item.value.hide && printData[item.value.hide + 'IsShow'] != 'Y')"></multilayerModelTemplate>
            </template>
          </div>
        </div>
      </template>
      <template v-else>
        <div v-for="item in printShowModel" :key="item.id">
          <div v-if="item.type === 'text'" :style="`text-align: ${item.float === 1 ? 'center' : (item.float === 2 ? 'right' : 'left')};`">
            {{ replaceVariables(item, templateHeadData, printData) }}
          </div>
          <div v-if="item.type === 'oneLineText'" :style="`text-align: ${item.float === 1 ? 'center' : (item.float === 2 ? 'right' : 'left')};`">
            <span v-for="(subItem, subIndex) in item.value" :key="subIndex">{{ replaceVariables(subItem, templateHeadData, printData) }}</span>
          </div>
          <div v-else-if="item.type === 'dividerConter'" :style="`text-align: ${item.float === 1 ? 'center' : (item.float === 2 ? 'right' : 'left')};`" class="dividerBox">
            <p class="divider"></p>
            <span>{{ replaceVariables(item, templateHeadData, printData) }}</span>
          </div>
          <div v-else-if="item.type === 'divider'">
            <p class="divider"></p>
          </div>
          <div v-else-if="item.type === 'textarea'" style="display: flex; justify-content: space-between;">
            <span v-for="(subItem, subIndex) in item.value" :key="subIndex">{{ replaceVariables(subItem, templateHeadData, printData) }}</span>
          </div>
          <div v-else-if="item.type === 'loop'">
            <div v-for="(detail, index) in templateDetailData" :key="index">
              <div v-for="loop in item.value" :key="loop.id">
                <div v-if="loop.type === 'text'" :style="`text-align: ${loop.float === 1 ? 'center' : (loop.float === 2 ? 'right' : 'left')};`">
                  {{ replaceVariables(loop, detail, printData) }}
                </div>
                <div v-if="loop.type === 'oneLineText'" :style="`text-align: ${loop.float === 1 ? 'center' : (loop.float === 2 ? 'right' : 'left')};`">
                  <span v-for="(subItem, subIndex) in loop.value" :key="subIndex">{{ replaceVariables(subItem, detail, printData) }}</span>
                </div>
                <div v-else-if="loop.type === 'dividerConter'" :style="`text-align: ${loop.float === 1 ? 'center' : (loop.float === 2 ? 'right' : 'left')};`" class="dividerBox">
                  <p class="divider"></p>
                  <span>{{ replaceVariables(loop, detail, printData) }}</span>
                </div>
                <div v-else-if="loop.type === 'divider'">
                  <p class="divider"></p>
                </div>
                <div v-else-if="loop.type === 'textarea'" style="display: flex; justify-content: space-between;">
                  <span v-for="(subItem, subIndex) in loop.value" :key="subIndex">
                    <span v-if="subItem.isShowIndex && replaceVariables(subItem, detail, printData)">{{ index + 1 }}.</span>
                    {{ replaceVariables(subItem, detail, printData) }}
                  </span>
                </div>
                <div v-else-if="loop.type === 'loop'">
                  <div v-for="(secondaryDetail, index) in detail.printItemDetailModels" :key="index">
                    <div v-for="secondaryLoop in loop.value" :key="secondaryLoop.id">
                      <div v-if="secondaryLoop.type === 'text'" :style="`text-align: ${secondaryLoop.float === 1 ? 'center' : (secondaryLoop.float === 2 ? 'right' : 'left')};`">
                        {{ replaceVariables(secondaryLoop, secondaryDetail, printData) }}
                      </div>
                      <div v-if="secondaryLoop.type === 'oneLineText'" :style="`text-align: ${secondaryLoop.float === 1 ? 'center' : (secondaryLoop.float === 2 ? 'right' : 'left')};`">
                        <span v-for="(subItem, subIndex) in secondaryLoop.value" :key="subIndex">{{ replaceVariables(subItem, secondaryDetail, printData) }}</span>
                      </div>
                      <div v-else-if="secondaryLoop.type === 'dividerConter'" :style="`text-align: ${secondaryLoop.float === 1 ? 'center' : (secondaryLoop.float === 2 ? 'right' : 'left')};`" class="dividerBox">
                        <p class="divider"></p>
                        <span>{{ replaceVariables(secondaryLoop, secondaryDetail, printData) }}</span>
                      </div>
                      <div v-else-if="secondaryLoop.type === 'divider'">
                        <p class="divider"></p>
                      </div>
                      <div v-else-if="secondaryLoop.type === 'textarea'" style="display: flex; justify-content: space-between;">
                        <span v-for="(subItem, subIndex) in secondaryLoop.value" :key="subIndex">
                          <span v-if="subItem.isShowIndex && replaceVariables(subItem, secondaryDetail, printData)">{{ index + 1 }}.</span>
                          {{ replaceVariables(subItem, secondaryDetail, printData) }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <!-- <div v-html="printHtml"></div> -->
      
    </div>
  </div>
</template>

<script>
import productTemplate from '@/components/print/productTemplate.vue'
import multilayerModelTemplate from '@/components/print/multilayerModelTemplate.vue'
import { replaceVariables } from '@/assets/js/appPrint';
export default {
  props: {
    type: String,
    enterpriseName: String,
    remark: String,
    billNo: String,
    printData: Object,
    templateId: {
      type: String,
      default: ''
    }
  },
  components: {
    productTemplate,
    multilayerModelTemplate
  },
  data() {
    return {
      templateHeadData: {},
      templateDetailData: [],
      power: {},
      /**
        type: 类型  text 单行文本 textarea 两边文本 divider 分割线 dividerConter 中间有内容的分割线 loop 循环内容
        value：展示字段
        float：水平方向   0 居左 1 居中 2 居右
        isShow：是否有权限判断展示
        isShowIndex：显示序号
        show: 单个字段控制整行是否显示 Y 显示， N隐藏
        none：单个字段控制整行是否显示，与show相反 N 显示， Y 隐藏
        以下只有isMultilayer==Y时适用
        loop中的value类型为{ source: Object, model: Array }[]
        source: 数据中要循环项对应的key值
        model: 模型
       */
      printShowModel: [],
      printHtml: '',
      version: 1,
      loading: true,
      isMultilayer: false
    }
  },
  mounted() {
    this.power = top.indexVm.$store.state.power
  },
  methods: {
    replaceVariables,
    updataData() {
      Promise.all([this.getPrintTemplateHead(), this.getPrintTemplateDetail()]).then(() => {
        console.log(4444444)
        this.getPrintShowModel()
      })
    },
    getPrintTemplateHead() {
      let url = ''
      if (['XSD', 'HHD'].includes(this.type)) {
        url = '/erpnew/account/c/reada46ceb/print/selectSalePrintHeadObj.html'
      } else if (['XST', 'CHD'].includes(this.type)) {
        url = '/erpnew/account/c/reada46ceb/print/selectReturnPrintHeadObj.html'
      } else if (['XSY', 'HDD'].includes(this.type)) {
        url = '/erpnew/account/c/reada46ceb/print/selectSaleOrderPrintHeadObj.html'
      } else if (this.type == 'CINV') {
        url = '/erpnew/account/c/reada46ceb/print/selectInvPrintObj.html'
      } else if (['XTY', 'CHDD'].includes(this.type)) {
        url = '/erpnew/account/c/reada46ceb/print/selectReturnOrderPrintHeadObj.html'
      } else if (this.type == 'DBD') {
        url = '/erpnew/account/c/reada46ceb/print/selectInvMovePrintHeadObj.html'
      } else if (this.type == 'DAILY') {
        url = '/erpnew/account/c/reada46ceb/print/selectDailyPrintObj.html'
      } else if (this.type == 'CXD') {
        url = '/erpnew/account/c/reada46ceb/print/selectVehiclesPrintDetailList.html'
      } else if (this.type == 'DHD') {
        url = '/erpnew/account/c/reada46ceb/print/selectOrderMeetPrintHeadObj.html'
      } else if (this.type == 'PKD') {
        url = '/erpnew/account/c/reada46ceb/print/selectInvCheckPrintHeadObj.html'
      } else if (this.type == 'DXD') {
        url = '/erpnew/account/c/reada46ceb/print/selectCustomerVisitPrintDetailList.html'
      } else if (['CGD', 'CGDD'].includes(this.type)) {
        url = '/erpnew/account/c/reada46ceb/print/selectReceivePrintHeadObj.html'
      } else if (['CGT', 'CGTD'].includes(this.type)) {
        url = '/erpnew/account/c/reada46ceb/print/selectReceiveReturnPrintHeadObj.html'
      } else if (this.type == 'XSIHZ') {
        url = '/erpnew/account/c/reada46ceb/print/selectItemSaleSumPrintDetailList.html'
      } else if (this.type == 'JHD') {
        url = '/erpnew/account/c/reada46ceb/print/selectLoanObj.html'
      } else if (this.type == 'JRD') {
        url = '/erpnew/account/c/reada46ceb/print/selectLoanReturnObj.html'
      } else if (this.type == 'FXYQ') {
        url = '/erpnew/account/c/reada46ceb/print/selectFXYQObj.html'
      } else if (this.type == 'FHDQ') {
        url = '/erpnew/account/c/reada46ceb/print/selectFHDQObj.html'
      } else if (this.type == 'FXYSA') {
        url = '/erpnew/account/c/reada46ceb/print/selectFXYSAObj.html'
      } else if (this.type == 'FHYSA') {
        url = '/erpnew/account/c/reada46ceb/print/selectFHYSAObj.html'
      } else if (this.type == 'FXYSB') {
        url = '/erpnew/account/c/reada46ceb/print/selectFXYSBObj.html'
      } else if (this.type == 'FHYSB') {
        url = '/erpnew/account/c/reada46ceb/print/selectFHYSBObj.html'
      } else if (this.type == 'FXYSC') {
        url = '/erpnew/account/c/reada46ceb/print/selectFXYSCObj.html'
      } else if (['FYDA', 'FYDC', 'FYDD', 'FYDE', 'FYDF', 'FYDG'].includes(this.type)) {
        url = '/erpnew/account/c/reada46ceb/print/selectFeeObj.html'
      } else if (this.type == 'FYDB') {
        url = '/erpnew/account/c/reada46ceb/print/selectFeeItemObj.html'
      } else if (this.type == 'WLHS') {
        url = '/erpnew/account/c/reada46ceb/print/selectWLHSBObj.html'
      } else if (this.type == 'WLTF') {
        url = '/erpnew/account/c/reada46ceb/print/selectWLTFObj.html'
      } else if (this.type == 'SYSD') {
        url = '/erpnew/account/c/reada46ceb/print/selectPayPreObj.html'
      } else if (this.type == 'SQKD') {
        url = '/erpnew/account/c/reada46ceb/print/selectPayArrearObj.html'
      } else if (this.type == 'ZHD') {
        url = '/erpnew/account/c/reada46ceb/print/selectSynthesizeObj.html'
      } else if (this.type == 'ZHDG') {
        url = '/erpnew/account/c/reada46ceb/print/selectSynthesizeGraduallyObj.html'
      } else if (this.type == 'FX') {
        url = '/erpnew/account/c/reada46ceb/print/selectVisitSaleObj.html'
      } else if (this.type == 'YGJZ') {
        url = '/erpnew/account/c/reada46ceb/print/selectCheckOutObj.html'
      } else if (this.type == 'DXDD') {
        url = '/erpnew/account/c/reada46ceb/print/selectShopPrintDetailList.html'
      }
      return new Promise((resolve) => {
        if (['DXDH'].includes(this.type)) {
          resolve(false)
        } else {
          this.$post(url, {
            billNo: this.billNo,
            isPrintTemplate: 'Y',
            printTemplateID: this.templateId
          }).then(({ data: res }) => {
            if (res.code != '0') return this.$alert(res.message, '提示', {
              confirmButtonText: '确定'
            })
            if (['CINV', 'CXD', 'DXD', 'XSIHZ', 'JHD', 'JRD', 'FXYSA', 'FHYSA', 'FXYSB', 'FHYSB', 'FYDB', 'WLHS', 'WLTF', 'SYSD', 'SQKD', 'ZHD', 'FX', 'YGJZ', 'DXDD'].includes(this.type)) {
              this.templateHeadData = res.data[0]
              this.templateDetailData = res.data.filter((i, index) => index != 0)
              resolve(false)
              return false
            }
            if (['ZHDG'].includes(this.type)) {
              this.templateHeadData = {}
              this.templateDetailData = res.data
              resolve(false)
              return false
            }
            this.templateHeadData = res.data
            resolve(true)
          })
        }
        
      })
    },
    getPrintTemplateDetail() {
      let url = ''
      if (['XSD', 'HHD'].includes(this.type)) {
        url = '/erpnew/account/c/reada46ceb/print/selectSalePrintDetailList.html'
      } else if (['XST', 'CHD'].includes(this.type)) {
        url = '/erpnew/account/c/reada46ceb/print/selectReturnPrintDetailList.html'
      } else if (['XSY', 'HDD'].includes(this.type)) {
        url = '/erpnew/account/c/reada46ceb/print/selectSaleOrderPrintDetailList.html'
      } else if (['XTY', 'CHDD'].includes(this.type)) {
        url = '/erpnew/account/c/reada46ceb/print/selectReturnOrderPrintDetailList.html'
      } else if (this.type == 'DBD') {
        url = '/erpnew/account/c/reada46ceb/print/selectInvMovePrintDetailList.html'
      } else if (this.type == 'DHD') {
        url = '/erpnew/account/c/reada46ceb/print/selectOrderMeetPrintDetailList.html'
      } else if (this.type == 'PKD') {
        url = '/erpnew/account/c/reada46ceb/print/selectInvCheckPrintDetailList.html'
      } else if (this.type == 'DXDH') {
        url = '/erpnew/account/c/reada46ceb/print/selectCustomerVisitPrintHeadObj.html'
      } else if (['CGD', 'CGDD'].includes(this.type)) {
        url = '/erpnew/account/c/reada46ceb/print/selectReceivePrintDetailList.html'
      } else if (['CGT', 'CGTD'].includes(this.type)) {
        url = '/erpnew/account/c/reada46ceb/print/selectReceiveReturnPrintDetailList.html'
      }

      return new Promise((resolve) => {
        if (['CINV', 'DAILY', 'CXD', 'DXD', 'XSIHZ', 'JHD', 'JRD', 'FXYQ', 'FHDQ', 'FXYSA', 'FHYSA', 'FXYSB', 'FHYSB', 'FXYSC', 'FYDA', 'FYDB', 'FYDC', 'FYDD', 'FYDE', 'FYDF', 'FYDG', 'WLHS', 'WLTF', 'SYSD', 'SQKD', 'ZHD', 'ZHDG', 'FX', 'YGJZ', 'DXDD'].includes(this.type)) {
          resolve(false)
        } else {
          this.$post(url, {
            billNo: this.billNo,
            isPrintTemplate: 'Y',
            printTemplateID: this.templateId
          }).then(({ data: res }) => {
            if (res.code != '0') return this.$alert(res.message, '提示', {
              confirmButtonText: '确定'
            })
            this.templateDetailData = res.data
            resolve(true)
          })
        }

      })
    },
    getPrintShowModel() {
      this.$post('/erpnew/account/c/reada46ceb/print/selectPrintModelList.html', {
        printSetType: this.type,
        isPc: 'Y',
        templateId: this.templateId // 模板id
      }).then(({ data: res }) => {
        this.loading = false
        if (res.code != '0') return this.$alert(res.message, '提示', {
          confirmButtonText: '确定'
        })
        if (res.data && res.data.length) {
          this.version = 2
          this.printShowModel = JSON.parse(res.data[0].printModel)
          this.isMultilayer = JSON.parse(res.data[0].isMultilayer == 'Y')
        } else {
          this.version = 1
          this.printShowModel = []
        }
      })
      this.templateHeadData.publicEnterpriseName = this.enterpriseName
      this.templateHeadData.publicRemark = this.remark
      if (['DBD', 'XSD', 'XSY', 'HHD', 'HDD', 'XST', 'XTY', 'CHD', 'CHDD', 'DHD'].includes(this.type)) {
        this.templateHeadData.billQtySumFormat = this.templateDetailData[0] && this.templateDetailData[0].billQtySumFormat
        this.templateHeadData.itemWeightSumFormat = this.templateDetailData[0] && this.templateDetailData[0].itemWeightSumFormat
        this.templateHeadData.itemWeightAveragePrice = this.templateDetailData[0] && this.templateDetailData[0].itemWeightAveragePrice
      }
      if (this.type == 'DAILY') {
        this.templateDetailData = this.templateHeadData.visitPrintHeadResponses
      }
      // this.printShowModel = [
      //   {
      //     "type": "text",
      //     "value": "{{appPrintCount}}",
      //     "float": 1,
      //     "isShow": true
      //   },
      //   {
      //     "type": "text",
      //     "value": "{{publicEnterpriseName}}",
      //     "float": 1
      //   },
      //   {
      //     "type": "dividerConter",
      //     "value": "销售日报",
      //     "float": 1
      //   },
      //   {
      //     "type": "textarea",
      //     "value": [
      //       {
      //         "value": "销售总金额：{{salTotalAmt}}元"
      //       },
      //       {
      //         "value": "退货总金额：{{salReturnTotalAmt}}元"
      //       }
      //     ]
      //   },
      //   {
      //     "type": "textarea",
      //     "value": [
      //       {
      //         "value": "订货总金额：{{meetTotalAmt}}元"
      //       },
      //       {
      //         "value": "费用金额：{{feeCashAmt}}元"
      //       }
      //     ]
      //   },
      //   {
      //     "type": "textarea",
      //     "value": [
      //       {
      //         "value": "{{putTotalAmtStr}}",
      //         "isShow": true
      //       },
      //       {
      //         "value": "{{recoveryTotalAmtStr}}",
      //         "isShow": true
      //       }
      //     ]
      //   },
      //   {
      //     "type": "textarea",
      //     "value": [
      //       {
      //         "value": "收欠款：{{payArrearAmt}}元"
      //       },
      //       {
      //         "value": "收预收款：{{payPrePayAmt}}元"
      //       }
      //     ]
      //   },
      //   {
      //     "type": "textarea",
      //     "value": [
      //       {
      //         "value": "冲抵欠款：{{subArrearAmt}}元"
      //       },
      //       {
      //         "value": "冲抵预收：{{subPrePayAmtAmt}}元"
      //       }
      //     ]
      //   },
      //   {
      //     "type": "textarea",
      //     "value": [
      //       {
      //         "value": "新增欠款：{{addArrearAmt}}元"
      //       },
      //       {
      //         "value": "新增预收：{{addPrePayAmtAmt}}元"
      //       }
      //     ]
      //   },
      //   {
      //     "type": "textarea",
      //     "value": [
      //       {
      //         "value": "应收金额：{{ysAmt}}元"
      //       },
      //       {
      //         "value": "优惠金额：{{discountAmt}}元"
      //       }
      //     ]
      //   },
      //   {
      //     "type": "text",
      //     "value": "实收金额：{{ssAmt}}元"
      //   },
      //   {
      //     "type": "divider",
      //     "value": ""
      //   },
      //   {
      //     "type": "text",
      //     "value": "业务员：{{salesmanName}}"
      //   },
      //   {
      //     "type": "textarea",
      //     "value": [
      //       {
      //         "value": "应上交金额：{{needHandPay}}元"
      //       },
      //       {
      //         "value": "已上交款：{{handPay}}元"
      //       }
      //     ]
      //   },
      //   {
      //     "type": "text",
      //     "value": "支付方式：{{payTypes}}"
      //   },
      //   {
      //     "type": "divider",
      //     "value": ""
      //   },
      //   {
      //     "type": "text",
      //     "value": "日期：{{beginDate}} - {{endDate}}"
      //   },
      //   {
      //     "type": "loop",
      //     "valueType": "Object",
      //     "valueKey": "billType",
      //     "value": {
      //       "DXD": {
      //         "show": "oldDaily",
      //         "model": [
      //           {
      //             "type": "dividerConter",
      //             "value": "拜访明细",
      //             "float": 1
      //           },
      //           {
      //             "type": "loop",
      //             "value": {
      //               "source": "visitPrintHeadResponses",
      //               "model": [
      //                 {
      //                   "type": "textarea",
      //                   "value": [
      //                     {
      //                       "value": "门店：{{customerName}} 应上缴：{{needHandPay}}元",
      //                       "isShowIndex": true
      //                     }
      //                   ]
      //                 },
      //                 {
      //                   "type": "oneLineText",
      //                   "show": "oldDaily",
      //                   "value": [
      //                     {
      //                       "value": "销售：{{salTotalAmt}}元 ",
      //                       "isShow": true
      //                     },
      //                     {
      //                       "value": "退货：{{salReturnTotalAmt}}元 ",
      //                       "isShow": true
      //                     },
      //                     {
      //                       "value": "优惠：{{discountAmt}}元 ",
      //                       "isShow": true
      //                     },
      //                     {
      //                       "value": "{{arrearAmtAdd}}"
      //                     },
      //                     {
      //                       "value": "{{arrearAmtSub}}"
      //                     },
      //                     {
      //                       "value": "{{prePayAmtAdd}} "
      //                     },
      //                     {
      //                       "value": "{{prePayAmtSub}} "
      //                     },
      //                     {
      //                       "value": "{{feeGoodsAmt}}"
      //                     }
      //                   ]
      //                 },
      //                 {
      //                   "type": "textarea",
      //                   "value": [
      //                     {
      //                       "value": "剩余欠款：{{arrearAmt}}元",
      //                       "show": "isPrintBalance"
      //                     },
      //                     {
      //                       "value": "剩余预收：{{prePayAmt}}元",
      //                       "show": "isPrintBalance"
      //                     }
      //                   ]
      //                 }
      //               ]
      //             }
      //           }
      //         ]
      //       },
      //       "XSD": {
      //         "show": "needHand",
      //         "model": [
      //           {
      //             "type": "divider",
      //             "value": ""
      //           },
      //           {
      //             "type": "text",
      //             "value": "{{title}}"
      //           },
      //           {
      //             "type": "loop",
      //             "value": {
      //               "source": "needHandModels",
      //               "model": [
      //                 {
      //                   "type": "textarea",
      //                   "value": [
      //                     {
      //                       "value": "{{itemName}}",
      //                       "isShowIndex": true
      //                     },
      //                     {
      //                       "value": "应收: {{salAmt}}"
      //                     }
      //                   ]
      //                 },
      //                 {
      //                   "type": "loop",
      //                   "value": {
      //                     "source": "itemModels",
      //                     "model": [
      //                       {
      //                         "type": "textarea",
      //                         "value": [
      //                           {
      //                             "value": "{{itemName}}"
      //                           },
      //                           {
      //                             "value": "{{billQtyFormat}}"
      //                           },
      //                           {
      //                             "value": "已结: {{salAmt}}"
      //                           }
      //                         ]
      //                       }
      //                     ]
      //                   }
      //                 }
      //               ]
      //             }
      //           }
      //         ]
      //       },
      //       "XST": {
      //         "show": "itemSum",
      //         "model": [
      //           {
      //             "type": "divider",
      //             "value": ""
      //           },
      //           {
      //             "type": "text",
      //             "value": "{{title}}"
      //           },
      //           {
      //             "type": "textarea",
      //             "value": [
      //               {
      //                 "value": "商品名称"
      //               },
      //               {
      //                 "value": "数量"
      //               },
      //               {
      //                 "value": "金额(元)"
      //               }
      //             ]
      //           },
      //           {
      //             "type": "loop",
      //             "value": {
      //               "source": "needHandModels",
      //               "model": [
      //                 {
      //                   "type": "textarea",
      //                   "value": [
      //                     {
      //                       "value": "{{itemName}}",
      //                       "isShowIndex": true
      //                     }
      //                   ]
      //                 },
      //                 {
      //                   "type": "loop",
      //                   "value": {
      //                     "source": "itemModels",
      //                     "model": [
      //                       {
      //                         "type": "textarea",
      //                         "value": [
      //                           {
      //                             "value": "{{itemName}}"
      //                           },
      //                           {
      //                             "value": "{{billQtyFormat}}"
      //                           },
      //                           {
      //                             "value": "{{salAmt}}"
      //                           }
      //                         ]
      //                       }
      //                     ]
      //                   }
      //                 },
      //                 {
      //                   "type": "textarea",
      //                   "value": [
      //                     {
      //                       "value": "合计"
      //                     },
      //                     {
      //                       "value": "{{billQtyFormat}}"
      //                     },
      //                     {
      //                       "value": "{{salAmt}}"
      //                     }
      //                   ]
      //                 }
      //               ]
      //             }
      //           }
      //         ]
      //       },
      //       "HHD": {
      //         "show": "customerItemSum",
      //         "model": [
      //           {
      //             "type": "divider",
      //             "value": ""
      //           },
      //           {
      //             "type": "text",
      //             "value": "{{title}}"
      //           },
      //           {
      //             "type": "loop",
      //             "value": {
      //               "source": "needHandModels",
      //               "model": [
      //                 {
      //                   "type": "textarea",
      //                   "value": [
      //                     {
      //                       "value": "{{itemName}}",
      //                       "isShowIndex": true
      //                     }
      //                   ]
      //                 },
      //                 {
      //                   "type": "loop",
      //                   "value": {
      //                     "source": "itemModels",
      //                     "model": [
      //                       {
      //                         "type": "textarea",
      //                         "value": [
      //                           {
      //                             "value": "{{itemName}}"
      //                           },
      //                           {
      //                             "value": "{{billQtyFormat}}"
      //                           },
      //                           {
      //                             "value": "{{salAmt}}"
      //                           }
      //                         ]
      //                       }
      //                     ]
      //                   }
      //                 },
      //                 {
      //                   "type": "textarea",
      //                   "value": [
      //                     {
      //                       "value": "合计"
      //                     },
      //                     {
      //                       "value": "{{billQtyFormat}}"
      //                     },
      //                     {
      //                       "value": "{{salAmt}}"
      //                     }
      //                   ]
      //                 }
      //               ]
      //             }
      //           }
      //         ]
      //       }
      //     }
      //   },
      //   {
      //     "type": "text",
      //     "value": "整单备注：{{billRemark}}",
      //     "isShow": true
      //   },
      //   {
      //     "type": "divider",
      //     "value": ""
      //   },
      //   {
      //     "type": "text",
      //     "value": "{{publicRemark}}"
      //   }
      // ]
      // this.printShowModel = [
      //   {
      //     "type": "text",
      //     "value": "{{appPrintCount}}",
      //     "float": 1,
      //     "isShow": true
      //   },
      //   {
      //     "type": "text",
      //     "value": "{{publicEnterpriseName}}",
      //     "float": 1
      //   },
      //   {
      //     "type": "divider",
      //     "value": ""
      //   },
      //   {
      //     "type": "text",
      //     "value": "{{customerName}}",
      //     "float": 1
      //   },
      //   {
      //     "type": "loop",
      //     "valueType": "Object",
      //     "valueKey": "printBillType",
      //     "value": {
      //       "XSD": {
      //         "show": "",
      //         "model": [
      //           {
      //             "type": "dividerConter",
      //             "value": "{{title}}",
      //             "float": 1
      //           },
      //           {
      //             "type": "loop",
      //             "value": {
      //               "source": "printItemDetailModels",
      //               "model": [
      //                 {
      //                   "type": "textarea",
      //                   "value": [
      //                     {
      //                       "value": "{{itemName}}({{itemSpec}})({{priceTypeDesc}})({{causeDesc}})({{salOrderMeetName}})",
      //                       "isShow": true,
      //                       "isShowIndex": true
      //                     }, {
      //                       "value": "{{salBarCode}}",
      //                       "show": "itemNameAndBarCode"
      //                     }, {
      //                       "value": "{{midBarCodeFormat}}",
      //                       "show": "itemNameAndBarCode"
      //                     }, {
      //                       "value": "{{invBarCodeFormat}}",
      //                       "show": "itemNameAndBarCode"
      //                     }
      //                   ]
      //                 },
      //                 {
      //                     "type": "textarea",
      //                     "value": [
      //                         {
      //                             "value": "{{invQtyFormat}}{{billQtyFormat}}",
      //                             "none": "priceFormat",
      //                             "isShow": true
      //                         },
      //                         {
      //                             "value": "{{salPriceFormat}}{{midPriceFormat}}{{invPriceFormat}}",
      //                             "isShow": true,
      //                             "none": "priceFormat"
      //                         },
      //                         {
      //                             "value": "{{totalAmt}}元",
      //                             "none": "priceFormat"
      //                         }
      //                     ]
      //                 },
      //                 {
      //                     "type": "textarea",
      //                     "value": [
      //                         {
      //                             "value": "{{invQtyFormat}}{{billQtyFormat}}",
      //                             "show": "priceFormat",
      //                             "isShow": true
      //                         },
      //                         {
      //                             "value": "{{priceFormat}}",
      //                             "show": "priceFormat",
      //                             "isShow": true
      //                         },
      //                         {
      //                             "value": "{{salPriceFormat}}{{midPriceFormat}}{{invPriceFormat}}",
      //                             "show": "priceFormat",
      //                             "none": "priceFormat"
      //                         },
      //                         {
      //                             "value": "{{totalAmt}}元",
      //                             "show": "priceFormat"
      //                         }
      //                     ]
      //                 }, {
      //                   "type": "text",
      //                   "value": "大单位条码：{{salBarCode}}",
      //                   "none": "itemNameAndBarCode",
      //                   "isShow": true
      //                 }, {
      //                   "type": "text",
      //                   "value": "中单位条码：{{midBarCode}}",
      //                   "none": "itemNameAndBarCode",
      //                   "isShow": true
      //                 }, {
      //                   "type": "text",
      //                   "value": "小单位条码：{{invBarCode}}",
      //                   "none": "itemNameAndBarCode",
      //                   "isShow": true
      //                 },
      //                 {
      //                     "type": "text",
      //                     "value": "生产日期：{{productionDate}}",
      //                     "isShow": true
      //                 },
      //                 {
      //                     "type": "textarea",
      //                     "value": [
      //                         {
      //                             "value": "建议零售价：{{salRetailPrice}}{{midRetailPrice}}{{invRetailPrice}}",
      //                             "isShow": true
      //                         },
      //                         {
      //                             "value": "重量：{{itemWeight}}",
      //                             "isShow": true
      //                         }
      //                     ]
      //                 },
      //                 {
      //                     "type": "textarea",
      //                     "value": [
      //                         {
      //                             "value": "生产厂家：{{productFactoryName}}",
      //                             "isShow": true
      //                         },
      //                         {
      //                             "value": "保质期：{{itemValid}}",
      //                             "isShow": true
      //                         }
      //                     ]
      //                 },
      //                 {
      //                     "type": "text",
      //                     "value": "备注：{{remark}}",
      //                     "isShow": true
      //                 },
      //                 {
      //                     "type": "divider",
      //                     "value": ""
      //                 }
      //               ]
      //             }
      //           },
      //           {
      //             "type": "textarea",
      //             "value": [
      //               {
      //                   "value": "总数量：{{billQtyFormat}}"
      //               },
      //               {
      //                   "value": "总金额：{{totalAmt}}元"
      //               }
      //             ]
      //           },
      //           {
      //             "type": "text",
      //             "value": "交易账户：{{accountName}}",
      //             "isShow": true
      //           }
      //         ]
      //       },
      //       "XST": {
      //         "show": "",
      //         "model": [
      //           {
      //             "type": "dividerConter",
      //             "value": "{{title}}",
      //             "float": 1
      //           },
      //           {
      //             "type": "loop",
      //             "value": {
      //               "source": "printItemDetailModels",
      //               "model": [
      //                 {
      //                   "type": "textarea",
      //                   "value": [
      //                     {
      //                       "value": "{{itemName}}({{itemSpec}})({{priceTypeDesc}})({{causeDesc}})({{salOrderMeetName}})",
      //                       "isShow": true,
      //                       "isShowIndex": true
      //                     }, {
      //                       "value": "{{salBarCode}}",
      //                       "show": "itemNameAndBarCode"
      //                     }, {
      //                       "value": "{{midBarCodeFormat}}",
      //                       "show": "itemNameAndBarCode"
      //                     }, {
      //                       "value": "{{invBarCodeFormat}}",
      //                       "show": "itemNameAndBarCode"
      //                     }
      //                   ]
      //                 },
      //                 {
      //                     "type": "textarea",
      //                     "value": [
      //                         {
      //                             "value": "{{invQtyFormat}}{{billQtyFormat}}",
      //                             "none": "priceFormat",
      //                             "isShow": true
      //                         },
      //                         {
      //                             "value": "{{salPriceFormat}}{{midPriceFormat}}{{invPriceFormat}}",
      //                             "isShow": true,
      //                             "none": "priceFormat"
      //                         },
      //                         {
      //                             "value": "{{totalAmt}}元",
      //                             "none": "priceFormat"
      //                         }
      //                     ]
      //                 },
      //                 {
      //                     "type": "textarea",
      //                     "value": [
      //                         {
      //                             "value": "{{invQtyFormat}}{{billQtyFormat}}",
      //                             "show": "priceFormat",
      //                             "isShow": true
      //                         },
      //                         {
      //                             "value": "{{priceFormat}}",
      //                             "show": "priceFormat",
      //                             "isShow": true
      //                         },
      //                         {
      //                             "value": "{{salPriceFormat}}{{midPriceFormat}}{{invPriceFormat}}",
      //                             "show": "priceFormat",
      //                             "none": "priceFormat"
      //                         },
      //                         {
      //                             "value": "{{totalAmt}}元",
      //                             "show": "priceFormat"
      //                         }
      //                     ]
      //                 }, {
      //                   "type": "text",
      //                   "value": "大单位条码：{{salBarCode}}",
      //                   "none": "itemNameAndBarCode",
      //                   "isShow": true
      //                 }, {
      //                   "type": "text",
      //                   "value": "中单位条码：{{midBarCode}}",
      //                   "none": "itemNameAndBarCode",
      //                   "isShow": true
      //                 }, {
      //                   "type": "text",
      //                   "value": "小单位条码：{{invBarCode}}",
      //                   "none": "itemNameAndBarCode",
      //                   "isShow": true
      //                 },
      //                 {
      //                     "type": "text",
      //                     "value": "生产日期：{{productionDate}}",
      //                     "isShow": true
      //                 },
      //                 {
      //                     "type": "textarea",
      //                     "value": [
      //                         {
      //                             "value": "建议零售价：{{salRetailPrice}}{{midRetailPrice}}{{invRetailPrice}}",
      //                             "isShow": true
      //                         },
      //                         {
      //                             "value": "重量：{{itemWeight}}",
      //                             "isShow": true
      //                         }
      //                     ]
      //                 },
      //                 {
      //                     "type": "textarea",
      //                     "value": [
      //                         {
      //                             "value": "生产厂家：{{productFactoryName}}",
      //                             "isShow": true
      //                         },
      //                         {
      //                             "value": "保质期：{{itemValid}}",
      //                             "isShow": true
      //                         }
      //                     ]
      //                 },
      //                 {
      //                     "type": "text",
      //                     "value": "备注：{{remark}}",
      //                     "isShow": true
      //                 },
      //                 {
      //                     "type": "divider",
      //                     "value": ""
      //                 }
      //               ]
      //             }
      //           },
      //           {
      //             "type": "textarea",
      //             "value": [
      //               {
      //                   "value": "总数量：{{billQtyFormat}}"
      //               },
      //               {
      //                   "value": "总金额：{{totalAmt}}元"
      //               }
      //             ]
      //           },
      //           {
      //             "type": "text",
      //             "value": "交易账户：{{accountName}}",
      //             "isShow": true
      //           }
      //         ]
      //       },
      //       "CHD": {
      //         "show": "",
      //         "model": [
      //           {
      //             "type": "dividerConter",
      //             "value": "{{title}}",
      //             "float": 1
      //           },
      //           {
      //             "type": "loop",
      //             "value": {
      //               "source": "printItemDetailModels",
      //               "model": [
      //                 {
      //                   "type": "textarea",
      //                   "value": [
      //                     {
      //                       "value": "{{itemName}}({{itemSpec}})({{priceTypeDesc}})({{causeDesc}})({{salOrderMeetName}})",
      //                       "isShow": true,
      //                       "isShowIndex": true
      //                     }, {
      //                       "value": "{{salBarCode}}",
      //                       "show": "itemNameAndBarCode"
      //                     }, {
      //                       "value": "{{midBarCodeFormat}}",
      //                       "show": "itemNameAndBarCode"
      //                     }, {
      //                       "value": "{{invBarCodeFormat}}",
      //                       "show": "itemNameAndBarCode"
      //                     }
      //                   ]
      //                 },
      //                 {
      //                     "type": "textarea",
      //                     "value": [
      //                         {
      //                             "value": "{{invQtyFormat}}{{billQtyFormat}}",
      //                             "none": "priceFormat",
      //                             "isShow": true
      //                         },
      //                         {
      //                             "value": "{{salPriceFormat}}{{midPriceFormat}}{{invPriceFormat}}",
      //                             "isShow": true,
      //                             "none": "priceFormat"
      //                         },
      //                         {
      //                             "value": "{{totalAmt}}元",
      //                             "none": "priceFormat"
      //                         }
      //                     ]
      //                 },
      //                 {
      //                     "type": "textarea",
      //                     "value": [
      //                         {
      //                             "value": "{{invQtyFormat}}{{billQtyFormat}}",
      //                             "show": "priceFormat",
      //                             "isShow": true
      //                         },
      //                         {
      //                             "value": "{{priceFormat}}",
      //                             "show": "priceFormat",
      //                             "isShow": true
      //                         },
      //                         {
      //                             "value": "{{salPriceFormat}}{{midPriceFormat}}{{invPriceFormat}}",
      //                             "show": "priceFormat",
      //                             "none": "priceFormat"
      //                         },
      //                         {
      //                             "value": "{{totalAmt}}元",
      //                             "show": "priceFormat"
      //                         }
      //                     ]
      //                 }, {
      //                   "type": "text",
      //                   "value": "大单位条码：{{salBarCode}}",
      //                   "none": "itemNameAndBarCode",
      //                   "isShow": true
      //                 }, {
      //                   "type": "text",
      //                   "value": "中单位条码：{{midBarCode}}",
      //                   "none": "itemNameAndBarCode",
      //                   "isShow": true
      //                 }, {
      //                   "type": "text",
      //                   "value": "小单位条码：{{invBarCode}}",
      //                   "none": "itemNameAndBarCode",
      //                   "isShow": true
      //                 },
      //                 {
      //                     "type": "text",
      //                     "value": "生产日期：{{productionDate}}",
      //                     "isShow": true
      //                 },
      //                 {
      //                     "type": "textarea",
      //                     "value": [
      //                         {
      //                             "value": "建议零售价：{{salRetailPrice}}{{midRetailPrice}}{{invRetailPrice}}",
      //                             "isShow": true
      //                         },
      //                         {
      //                             "value": "重量：{{itemWeight}}",
      //                             "isShow": true
      //                         }
      //                     ]
      //                 },
      //                 {
      //                     "type": "textarea",
      //                     "value": [
      //                         {
      //                             "value": "生产厂家：{{productFactoryName}}",
      //                             "isShow": true
      //                         },
      //                         {
      //                             "value": "保质期：{{itemValid}}",
      //                             "isShow": true
      //                         }
      //                     ]
      //                 },
      //                 {
      //                     "type": "text",
      //                     "value": "备注：{{remark}}",
      //                     "isShow": true
      //                 },
      //                 {
      //                     "type": "divider",
      //                     "value": ""
      //                 }
      //               ]
      //             }
      //           },
      //           {
      //             "type": "textarea",
      //             "value": [
      //               {
      //                   "value": "总数量：{{billQtyFormat}}"
      //               },
      //               {
      //                   "value": "总金额：{{totalAmt}}元"
      //               }
      //             ]
      //           },
      //           {
      //             "type": "text",
      //             "value": "交易账户：{{accountName}}",
      //             "isShow": true
      //           }
      //         ]
      //       },
      //       "HHD": {
      //         "show": "",
      //         "model": [
      //           {
      //             "type": "dividerConter",
      //             "value": "{{title}}",
      //             "float": 1
      //           },
      //           {
      //             "type": "loop",
      //             "value": {
      //               "source": "printItemDetailModels",
      //               "model": [
      //                 {
      //                   "type": "textarea",
      //                   "value": [
      //                     {
      //                       "value": "{{itemName}}({{itemSpec}})({{priceTypeDesc}})({{causeDesc}})({{salOrderMeetName}})",
      //                       "isShow": true,
      //                       "isShowIndex": true
      //                     }, {
      //                       "value": "{{salBarCode}}",
      //                       "show": "itemNameAndBarCode"
      //                     }, {
      //                       "value": "{{midBarCodeFormat}}",
      //                       "show": "itemNameAndBarCode"
      //                     }, {
      //                       "value": "{{invBarCodeFormat}}",
      //                       "show": "itemNameAndBarCode"
      //                     }
      //                   ]
      //                 },
      //                 {
      //                     "type": "textarea",
      //                     "value": [
      //                         {
      //                             "value": "{{invQtyFormat}}{{billQtyFormat}}",
      //                             "none": "priceFormat",
      //                             "isShow": true
      //                         },
      //                         {
      //                             "value": "{{salPriceFormat}}{{midPriceFormat}}{{invPriceFormat}}",
      //                             "isShow": true,
      //                             "none": "priceFormat"
      //                         },
      //                         {
      //                             "value": "{{totalAmt}}元",
      //                             "none": "priceFormat"
      //                         }
      //                     ]
      //                 },
      //                 {
      //                     "type": "textarea",
      //                     "value": [
      //                         {
      //                             "value": "{{invQtyFormat}}{{billQtyFormat}}",
      //                             "show": "priceFormat",
      //                             "isShow": true
      //                         },
      //                         {
      //                             "value": "{{priceFormat}}",
      //                             "show": "priceFormat",
      //                             "isShow": true
      //                         },
      //                         {
      //                             "value": "{{salPriceFormat}}{{midPriceFormat}}{{invPriceFormat}}",
      //                             "show": "priceFormat",
      //                             "none": "priceFormat"
      //                         },
      //                         {
      //                             "value": "{{totalAmt}}元",
      //                             "show": "priceFormat"
      //                         }
      //                     ]
      //                 }, {
      //                   "type": "text",
      //                   "value": "大单位条码：{{salBarCode}}",
      //                   "none": "itemNameAndBarCode",
      //                   "isShow": true
      //                 }, {
      //                   "type": "text",
      //                   "value": "中单位条码：{{midBarCode}}",
      //                   "none": "itemNameAndBarCode",
      //                   "isShow": true
      //                 }, {
      //                   "type": "text",
      //                   "value": "小单位条码：{{invBarCode}}",
      //                   "none": "itemNameAndBarCode",
      //                   "isShow": true
      //                 },
      //                 {
      //                     "type": "text",
      //                     "value": "生产日期：{{productionDate}}",
      //                     "isShow": true
      //                 },
      //                 {
      //                     "type": "textarea",
      //                     "value": [
      //                         {
      //                             "value": "建议零售价：{{salRetailPrice}}{{midRetailPrice}}{{invRetailPrice}}",
      //                             "isShow": true
      //                         },
      //                         {
      //                             "value": "重量：{{itemWeight}}",
      //                             "isShow": true
      //                         }
      //                     ]
      //                 },
      //                 {
      //                     "type": "textarea",
      //                     "value": [
      //                         {
      //                             "value": "生产厂家：{{productFactoryName}}",
      //                             "isShow": true
      //                         },
      //                         {
      //                             "value": "保质期：{{itemValid}}",
      //                             "isShow": true
      //                         }
      //                     ]
      //                 },
      //                 {
      //                     "type": "text",
      //                     "value": "备注：{{remark}}",
      //                     "isShow": true
      //                 },
      //                 {
      //                     "type": "divider",
      //                     "value": ""
      //                 }
      //               ]
      //             }
      //           },
      //           {
      //             "type": "textarea",
      //             "value": [
      //               {
      //                   "value": "总数量：{{billQtyFormat}}"
      //               },
      //               {
      //                   "value": "总金额：{{totalAmt}}元"
      //               }
      //             ]
      //           },
      //           {
      //             "type": "text",
      //             "value": "交易账户：{{accountName}}",
      //             "isShow": true
      //           }
      //         ]
      //       },
      //       "DHD": {
      //         "show": "",
      //         "model": [
      //           {
      //             "type": "dividerConter",
      //             "value": "{{title}}",
      //             "float": 1
      //           },
      //           {
      //             "type": "loop",
      //             "value": {
      //               "source": "printItemDetailModels",
      //               "model": [
      //                 {
      //                   "type": "textarea",
      //                   "value": [
      //                     {
      //                       "value": "{{itemName}}({{itemSpec}})({{priceTypeDesc}})({{causeDesc}})({{salOrderMeetName}})",
      //                       "isShow": true,
      //                       "isShowIndex": true
      //                     }, {
      //                       "value": "{{salBarCode}}",
      //                       "show": "itemNameAndBarCode"
      //                     }, {
      //                       "value": "{{midBarCodeFormat}}",
      //                       "show": "itemNameAndBarCode"
      //                     }, {
      //                       "value": "{{invBarCodeFormat}}",
      //                       "show": "itemNameAndBarCode"
      //                     }
      //                   ]
      //                 },
      //                 {
      //                     "type": "textarea",
      //                     "value": [
      //                         {
      //                             "value": "{{invQtyFormat}}{{billQtyFormat}}",
      //                             "none": "priceFormat",
      //                             "isShow": true
      //                         },
      //                         {
      //                             "value": "{{salPriceFormat}}{{midPriceFormat}}{{invPriceFormat}}",
      //                             "isShow": true,
      //                             "none": "priceFormat"
      //                         },
      //                         {
      //                             "value": "{{totalAmt}}元",
      //                             "none": "priceFormat"
      //                         }
      //                     ]
      //                 },
      //                 {
      //                     "type": "textarea",
      //                     "value": [
      //                         {
      //                             "value": "{{invQtyFormat}}{{billQtyFormat}}",
      //                             "show": "priceFormat",
      //                             "isShow": true
      //                         },
      //                         {
      //                             "value": "{{priceFormat}}",
      //                             "show": "priceFormat",
      //                             "isShow": true
      //                         },
      //                         {
      //                             "value": "{{salPriceFormat}}{{midPriceFormat}}{{invPriceFormat}}",
      //                             "show": "priceFormat",
      //                             "none": "priceFormat"
      //                         },
      //                         {
      //                             "value": "{{totalAmt}}元",
      //                             "show": "priceFormat"
      //                         }
      //                     ]
      //                 }, {
      //                   "type": "text",
      //                   "value": "大单位条码：{{salBarCode}}",
      //                   "none": "itemNameAndBarCode",
      //                   "isShow": true
      //                 }, {
      //                   "type": "text",
      //                   "value": "中单位条码：{{midBarCode}}",
      //                   "none": "itemNameAndBarCode",
      //                   "isShow": true
      //                 }, {
      //                   "type": "text",
      //                   "value": "小单位条码：{{invBarCode}}",
      //                   "none": "itemNameAndBarCode",
      //                   "isShow": true
      //                 },
      //                 {
      //                     "type": "text",
      //                     "value": "生产日期：{{productionDate}}",
      //                     "isShow": true
      //                 },
      //                 {
      //                     "type": "textarea",
      //                     "value": [
      //                         {
      //                             "value": "建议零售价：{{salRetailPrice}}{{midRetailPrice}}{{invRetailPrice}}",
      //                             "isShow": true
      //                         },
      //                         {
      //                             "value": "重量：{{itemWeight}}",
      //                             "isShow": true
      //                         }
      //                     ]
      //                 },
      //                 {
      //                     "type": "textarea",
      //                     "value": [
      //                         {
      //                             "value": "生产厂家：{{productFactoryName}}",
      //                             "isShow": true
      //                         },
      //                         {
      //                             "value": "保质期：{{itemValid}}",
      //                             "isShow": true
      //                         }
      //                     ]
      //                 },
      //                 {
      //                     "type": "text",
      //                     "value": "备注：{{remark}}",
      //                     "isShow": true
      //                 },
      //                 {
      //                     "type": "divider",
      //                     "value": ""
      //                 }
      //               ]
      //             }
      //           },
      //           {
      //             "type": "textarea",
      //             "value": [
      //               {
      //                   "value": "总数量：{{billQtyFormat}}"
      //               },
      //               {
      //                   "value": "总金额：{{totalAmt}}元"
      //               }
      //             ]
      //           },
      //           {
      //             "type": "text",
      //             "value": "交易账户：{{accountName}}",
      //             "isShow": true
      //           }
      //         ]
      //       },
      //       "HDD": {
      //         "show": "",
      //         "model": [
      //           {
      //             "type": "dividerConter",
      //             "value": "{{title}}",
      //             "float": 1
      //           },
      //           {
      //             "type": "loop",
      //             "value": {
      //               "source": "printItemDetailModels",
      //               "model": [
      //                 {
      //                   "type": "textarea",
      //                   "value": [
      //                     {
      //                       "value": "{{itemName}}({{itemSpec}})({{priceTypeDesc}})({{causeDesc}})({{salOrderMeetName}})",
      //                       "isShow": true,
      //                       "isShowIndex": true
      //                     }, {
      //                       "value": "{{salBarCode}}",
      //                       "show": "itemNameAndBarCode"
      //                     }, {
      //                       "value": "{{midBarCodeFormat}}",
      //                       "show": "itemNameAndBarCode"
      //                     }, {
      //                       "value": "{{invBarCodeFormat}}",
      //                       "show": "itemNameAndBarCode"
      //                     }
      //                   ]
      //                 },
      //                 {
      //                     "type": "textarea",
      //                     "value": [
      //                         {
      //                             "value": "{{invQtyFormat}}{{billQtyFormat}}",
      //                             "none": "priceFormat",
      //                             "isShow": true
      //                         },
      //                         {
      //                             "value": "{{salPriceFormat}}{{midPriceFormat}}{{invPriceFormat}}",
      //                             "isShow": true,
      //                             "none": "priceFormat"
      //                         },
      //                         {
      //                             "value": "{{totalAmt}}元",
      //                             "none": "priceFormat"
      //                         }
      //                     ]
      //                 },
      //                 {
      //                     "type": "textarea",
      //                     "value": [
      //                         {
      //                             "value": "{{invQtyFormat}}{{billQtyFormat}}",
      //                             "show": "priceFormat",
      //                             "isShow": true
      //                         },
      //                         {
      //                             "value": "{{priceFormat}}",
      //                             "show": "priceFormat",
      //                             "isShow": true
      //                         },
      //                         {
      //                             "value": "{{salPriceFormat}}{{midPriceFormat}}{{invPriceFormat}}",
      //                             "show": "priceFormat",
      //                             "none": "priceFormat"
      //                         },
      //                         {
      //                             "value": "{{totalAmt}}元",
      //                             "show": "priceFormat"
      //                         }
      //                     ]
      //                 }, {
      //                   "type": "text",
      //                   "value": "大单位条码：{{salBarCode}}",
      //                   "none": "itemNameAndBarCode",
      //                   "isShow": true
      //                 }, {
      //                   "type": "text",
      //                   "value": "中单位条码：{{midBarCode}}",
      //                   "none": "itemNameAndBarCode",
      //                   "isShow": true
      //                 }, {
      //                   "type": "text",
      //                   "value": "小单位条码：{{invBarCode}}",
      //                   "none": "itemNameAndBarCode",
      //                   "isShow": true
      //                 },
      //                 {
      //                     "type": "text",
      //                     "value": "生产日期：{{productionDate}}",
      //                     "isShow": true
      //                 },
      //                 {
      //                     "type": "textarea",
      //                     "value": [
      //                         {
      //                             "value": "建议零售价：{{salRetailPrice}}{{midRetailPrice}}{{invRetailPrice}}",
      //                             "isShow": true
      //                         },
      //                         {
      //                             "value": "重量：{{itemWeight}}",
      //                             "isShow": true
      //                         }
      //                     ]
      //                 },
      //                 {
      //                     "type": "textarea",
      //                     "value": [
      //                         {
      //                             "value": "生产厂家：{{productFactoryName}}",
      //                             "isShow": true
      //                         },
      //                         {
      //                             "value": "保质期：{{itemValid}}",
      //                             "isShow": true
      //                         }
      //                     ]
      //                 },
      //                 {
      //                     "type": "text",
      //                     "value": "备注：{{remark}}",
      //                     "isShow": true
      //                 },
      //                 {
      //                     "type": "divider",
      //                     "value": ""
      //                 }
      //               ]
      //             }
      //           },
      //           {
      //             "type": "textarea",
      //             "value": [
      //               {
      //                   "value": "总数量：{{billQtyFormat}}"
      //               },
      //               {
      //                   "value": "总金额：{{totalAmt}}元"
      //               }
      //             ]
      //           },
      //           {
      //             "type": "text",
      //             "value": "交易账户：{{accountName}}",
      //             "isShow": true
      //           }
      //         ]
      //       },
      //       "XSY": {
      //         "show": "",
      //         "model": [
      //           {
      //             "type": "dividerConter",
      //             "value": "{{title}}",
      //             "float": 1
      //           },
      //           {
      //             "type": "loop",
      //             "value": {
      //               "source": "printItemDetailModels",
      //               "model": [
      //                 {
      //                   "type": "textarea",
      //                   "value": [
      //                     {
      //                       "value": "{{itemName}}({{itemSpec}})({{priceTypeDesc}})({{causeDesc}})({{salOrderMeetName}})",
      //                       "isShow": true,
      //                       "isShowIndex": true
      //                     }, {
      //                       "value": "{{salBarCode}}",
      //                       "show": "itemNameAndBarCode"
      //                     }, {
      //                       "value": "{{midBarCodeFormat}}",
      //                       "show": "itemNameAndBarCode"
      //                     }, {
      //                       "value": "{{invBarCodeFormat}}",
      //                       "show": "itemNameAndBarCode"
      //                     }
      //                   ]
      //                 },
      //                 {
      //                     "type": "textarea",
      //                     "value": [
      //                         {
      //                             "value": "{{invQtyFormat}}{{billQtyFormat}}",
      //                             "none": "priceFormat",
      //                             "isShow": true
      //                         },
      //                         {
      //                             "value": "{{salPriceFormat}}{{midPriceFormat}}{{invPriceFormat}}",
      //                             "isShow": true,
      //                             "none": "priceFormat"
      //                         },
      //                         {
      //                             "value": "{{totalAmt}}元",
      //                             "none": "priceFormat"
      //                         }
      //                     ]
      //                 },
      //                 {
      //                     "type": "textarea",
      //                     "value": [
      //                         {
      //                             "value": "{{invQtyFormat}}{{billQtyFormat}}",
      //                             "show": "priceFormat",
      //                             "isShow": true
      //                         },
      //                         {
      //                             "value": "{{priceFormat}}",
      //                             "show": "priceFormat",
      //                             "isShow": true
      //                         },
      //                         {
      //                             "value": "{{salPriceFormat}}{{midPriceFormat}}{{invPriceFormat}}",
      //                             "show": "priceFormat",
      //                             "none": "priceFormat"
      //                         },
      //                         {
      //                             "value": "{{totalAmt}}元",
      //                             "show": "priceFormat"
      //                         }
      //                     ]
      //                 }, {
      //                   "type": "text",
      //                   "value": "大单位条码：{{salBarCode}}",
      //                   "none": "itemNameAndBarCode",
      //                   "isShow": true
      //                 }, {
      //                   "type": "text",
      //                   "value": "中单位条码：{{midBarCode}}",
      //                   "none": "itemNameAndBarCode",
      //                   "isShow": true
      //                 }, {
      //                   "type": "text",
      //                   "value": "小单位条码：{{invBarCode}}",
      //                   "none": "itemNameAndBarCode",
      //                   "isShow": true
      //                 },
      //                 {
      //                     "type": "text",
      //                     "value": "生产日期：{{productionDate}}",
      //                     "isShow": true
      //                 },
      //                 {
      //                     "type": "textarea",
      //                     "value": [
      //                         {
      //                             "value": "建议零售价：{{salRetailPrice}}{{midRetailPrice}}{{invRetailPrice}}",
      //                             "isShow": true
      //                         },
      //                         {
      //                             "value": "重量：{{itemWeight}}",
      //                             "isShow": true
      //                         }
      //                     ]
      //                 },
      //                 {
      //                     "type": "textarea",
      //                     "value": [
      //                         {
      //                             "value": "生产厂家：{{productFactoryName}}",
      //                             "isShow": true
      //                         },
      //                         {
      //                             "value": "保质期：{{itemValid}}",
      //                             "isShow": true
      //                         }
      //                     ]
      //                 },
      //                 {
      //                     "type": "text",
      //                     "value": "备注：{{remark}}",
      //                     "isShow": true
      //                 },
      //                 {
      //                     "type": "divider",
      //                     "value": ""
      //                 }
      //               ]
      //             }
      //           },
      //           {
      //             "type": "textarea",
      //             "value": [
      //               {
      //                   "value": "总数量：{{billQtyFormat}}"
      //               },
      //               {
      //                   "value": "总金额：{{totalAmt}}元"
      //               }
      //             ]
      //           },
      //           {
      //             "type": "text",
      //             "value": "交易账户：{{accountName}}",
      //             "isShow": true
      //           }
      //         ]
      //       },
      //       "XTY": {
      //         "show": "",
      //         "model": [
      //           {
      //             "type": "dividerConter",
      //             "value": "{{title}}",
      //             "float": 1
      //           },
      //           {
      //             "type": "loop",
      //             "value": {
      //               "source": "printItemDetailModels",
      //               "model": [
      //                 {
      //                   "type": "textarea",
      //                   "value": [
      //                     {
      //                       "value": "{{itemName}}({{itemSpec}})({{priceTypeDesc}})({{causeDesc}})({{salOrderMeetName}})",
      //                       "isShow": true,
      //                       "isShowIndex": true
      //                     }, {
      //                       "value": "{{salBarCode}}",
      //                       "show": "itemNameAndBarCode"
      //                     }, {
      //                       "value": "{{midBarCodeFormat}}",
      //                       "show": "itemNameAndBarCode"
      //                     }, {
      //                       "value": "{{invBarCodeFormat}}",
      //                       "show": "itemNameAndBarCode"
      //                     }
      //                   ]
      //                 },
      //                 {
      //                     "type": "textarea",
      //                     "value": [
      //                         {
      //                             "value": "{{invQtyFormat}}{{billQtyFormat}}",
      //                             "none": "priceFormat",
      //                             "isShow": true
      //                         },
      //                         {
      //                             "value": "{{salPriceFormat}}{{midPriceFormat}}{{invPriceFormat}}",
      //                             "isShow": true,
      //                             "none": "priceFormat"
      //                         },
      //                         {
      //                             "value": "{{totalAmt}}元",
      //                             "none": "priceFormat"
      //                         }
      //                     ]
      //                 },
      //                 {
      //                     "type": "textarea",
      //                     "value": [
      //                         {
      //                             "value": "{{invQtyFormat}}{{billQtyFormat}}",
      //                             "show": "priceFormat",
      //                             "isShow": true
      //                         },
      //                         {
      //                             "value": "{{priceFormat}}",
      //                             "show": "priceFormat",
      //                             "isShow": true
      //                         },
      //                         {
      //                             "value": "{{salPriceFormat}}{{midPriceFormat}}{{invPriceFormat}}",
      //                             "show": "priceFormat",
      //                             "none": "priceFormat"
      //                         },
      //                         {
      //                             "value": "{{totalAmt}}元",
      //                             "show": "priceFormat"
      //                         }
      //                     ]
      //                 }, {
      //                   "type": "text",
      //                   "value": "大单位条码：{{salBarCode}}",
      //                   "none": "itemNameAndBarCode",
      //                   "isShow": true
      //                 }, {
      //                   "type": "text",
      //                   "value": "中单位条码：{{midBarCode}}",
      //                   "none": "itemNameAndBarCode",
      //                   "isShow": true
      //                 }, {
      //                   "type": "text",
      //                   "value": "小单位条码：{{invBarCode}}",
      //                   "none": "itemNameAndBarCode",
      //                   "isShow": true
      //                 },
      //                 {
      //                     "type": "text",
      //                     "value": "生产日期：{{productionDate}}",
      //                     "isShow": true
      //                 },
      //                 {
      //                     "type": "textarea",
      //                     "value": [
      //                         {
      //                             "value": "建议零售价：{{salRetailPrice}}{{midRetailPrice}}{{invRetailPrice}}",
      //                             "isShow": true
      //                         },
      //                         {
      //                             "value": "重量：{{itemWeight}}",
      //                             "isShow": true
      //                         }
      //                     ]
      //                 },
      //                 {
      //                     "type": "textarea",
      //                     "value": [
      //                         {
      //                             "value": "生产厂家：{{productFactoryName}}",
      //                             "isShow": true
      //                         },
      //                         {
      //                             "value": "保质期：{{itemValid}}",
      //                             "isShow": true
      //                         }
      //                     ]
      //                 },
      //                 {
      //                     "type": "text",
      //                     "value": "备注：{{remark}}",
      //                     "isShow": true
      //                 },
      //                 {
      //                     "type": "divider",
      //                     "value": ""
      //                 }
      //               ]
      //             }
      //           },
      //           {
      //             "type": "textarea",
      //             "value": [
      //               {
      //                   "value": "总数量：{{billQtyFormat}}"
      //               },
      //               {
      //                   "value": "总金额：{{totalAmt}}元"
      //               }
      //             ]
      //           },
      //           {
      //             "type": "text",
      //             "value": "交易账户：{{accountName}}",
      //             "isShow": true
      //           }
      //         ]
      //       },
      //       "CHDD": {
      //         "show": "",
      //         "model": [
      //           {
      //             "type": "dividerConter",
      //             "value": "{{title}}",
      //             "float": 1
      //           },
      //           {
      //             "type": "loop",
      //             "value": {
      //               "source": "printItemDetailModels",
      //               "model": [
      //                 {
      //                   "type": "textarea",
      //                   "value": [
      //                     {
      //                       "value": "{{itemName}}({{itemSpec}})({{priceTypeDesc}})({{causeDesc}})({{salOrderMeetName}})",
      //                       "isShow": true,
      //                       "isShowIndex": true
      //                     }, {
      //                       "value": "{{salBarCode}}",
      //                       "show": "itemNameAndBarCode"
      //                     }, {
      //                       "value": "{{midBarCodeFormat}}",
      //                       "show": "itemNameAndBarCode"
      //                     }, {
      //                       "value": "{{invBarCodeFormat}}",
      //                       "show": "itemNameAndBarCode"
      //                     }
      //                   ]
      //                 },
      //                 {
      //                     "type": "textarea",
      //                     "value": [
      //                         {
      //                             "value": "{{invQtyFormat}}{{billQtyFormat}}",
      //                             "none": "priceFormat",
      //                             "isShow": true
      //                         },
      //                         {
      //                             "value": "{{salPriceFormat}}{{midPriceFormat}}{{invPriceFormat}}",
      //                             "isShow": true,
      //                             "none": "priceFormat"
      //                         },
      //                         {
      //                             "value": "{{totalAmt}}元",
      //                             "none": "priceFormat"
      //                         }
      //                     ]
      //                 },
      //                 {
      //                     "type": "textarea",
      //                     "value": [
      //                         {
      //                             "value": "{{invQtyFormat}}{{billQtyFormat}}",
      //                             "show": "priceFormat",
      //                             "isShow": true
      //                         },
      //                         {
      //                             "value": "{{priceFormat}}",
      //                             "show": "priceFormat",
      //                             "isShow": true
      //                         },
      //                         {
      //                             "value": "{{salPriceFormat}}{{midPriceFormat}}{{invPriceFormat}}",
      //                             "show": "priceFormat",
      //                             "none": "priceFormat"
      //                         },
      //                         {
      //                             "value": "{{totalAmt}}元",
      //                             "show": "priceFormat"
      //                         }
      //                     ]
      //                 }, {
      //                   "type": "text",
      //                   "value": "大单位条码：{{salBarCode}}",
      //                   "none": "itemNameAndBarCode",
      //                   "isShow": true
      //                 }, {
      //                   "type": "text",
      //                   "value": "中单位条码：{{midBarCode}}",
      //                   "none": "itemNameAndBarCode",
      //                   "isShow": true
      //                 }, {
      //                   "type": "text",
      //                   "value": "小单位条码：{{invBarCode}}",
      //                   "none": "itemNameAndBarCode",
      //                   "isShow": true
      //                 },
      //                 {
      //                     "type": "text",
      //                     "value": "生产日期：{{productionDate}}",
      //                     "isShow": true
      //                 },
      //                 {
      //                     "type": "textarea",
      //                     "value": [
      //                         {
      //                             "value": "建议零售价：{{salRetailPrice}}{{midRetailPrice}}{{invRetailPrice}}",
      //                             "isShow": true
      //                         },
      //                         {
      //                             "value": "重量：{{itemWeight}}",
      //                             "isShow": true
      //                         }
      //                     ]
      //                 },
      //                 {
      //                     "type": "textarea",
      //                     "value": [
      //                         {
      //                             "value": "生产厂家：{{productFactoryName}}",
      //                             "isShow": true
      //                         },
      //                         {
      //                             "value": "保质期：{{itemValid}}",
      //                             "isShow": true
      //                         }
      //                     ]
      //                 },
      //                 {
      //                     "type": "text",
      //                     "value": "备注：{{remark}}",
      //                     "isShow": true
      //                 },
      //                 {
      //                     "type": "divider",
      //                     "value": ""
      //                 }
      //               ]
      //             }
      //           },
      //           {
      //             "type": "textarea",
      //             "value": [
      //               {
      //                   "value": "总数量：{{billQtyFormat}}"
      //               },
      //               {
      //                   "value": "总金额：{{totalAmt}}元"
      //               }
      //             ]
      //           },
      //           {
      //             "type": "text",
      //             "value": "交易账户：{{accountName}}",
      //             "isShow": true
      //           }
      //         ]
      //       },
      //       "SYSD": {
      //         "show": "",
      //         "model": [
      //           {
      //             "type": "dividerConter",
      //             "value": "{{title}}",
      //             "float": 1
      //           },
      //           {
      //             "type": "loop",
      //             "value": {
      //               "source": "payItems",
      //               "model": [
      //                 {
      //                   "type": "textarea",
      //                   "value": [
      //                     {
      //                       "value": "{{collectionInfo}}",
      //                       "isShowIndex": true
      //                     }
      //                   ]
      //                 },
      //                 {
      //                   "type": "text",
      //                   "value": "交易账户：{{accountName}}",
      //                   "isShow": true
      //                 }
      //               ]
      //             }
      //           }
      //         ]
      //       },
      //       "SQKD": {
      //         "show": "",
      //         "model": [
      //           {
      //             "type": "dividerConter",
      //             "value": "{{title}}",
      //             "float": 1
      //           },
      //           {
      //             "type": "loop",
      //             "value": {
      //               "source": "payItems",
      //               "model": [
      //                 {
      //                   "type": "textarea",
      //                   "value": [
      //                     {
      //                       "value": "{{collectionInfo}}",
      //                       "isShowIndex": true
      //                     }
      //                   ]
      //                 },
      //                 {
      //                   "type": "text",
      //                   "value": "交易账户：{{accountName}}",
      //                   "isShow": true
      //                 }
      //               ]
      //             }
      //           }
      //         ]
      //       },
      //       "FYDA": {
      //         "show": "",
      //         "model": [
      //           {
      //             "type": "dividerConter",
      //             "value": "{{title}}",
      //             "float": 1
      //           },
      //           {
      //             "type": "loop",
      //             "value": {
      //               "source": "payItems",
      //               "model": [
      //                 {
      //                   "type": "textarea",
      //                   "value": [
      //                     {
      //                       "value": "{{collectionInfo}}",
      //                       "isShowIndex": true
      //                     }
      //                   ]
      //                 },
      //                 {
      //                   "type": "text",
      //                   "value": "交易账户：{{accountName}}",
      //                   "isShow": true
      //                 }
      //               ]
      //             }
      //           }
      //         ]
      //       },
      //       "FYDB": {
      //         "show": "",
      //         "model": [
      //           {
      //             "type": "dividerConter",
      //             "value": "{{title}}",
      //             "float": 1
      //           },
      //           {
      //             "type": "loop",
      //             "value": {
      //               "source": "payItems",
      //               "model": [
      //                 {
      //                   "type": "textarea",
      //                   "value": [
      //                     {
      //                       "value": "{{collectionInfo}}",
      //                       "isShowIndex": true
      //                     }
      //                   ]
      //                 },
      //                 {
      //                   "type": "text",
      //                   "value": "交易账户：{{accountName}}",
      //                   "isShow": true
      //                 }
      //               ]
      //             }
      //           }
      //         ]
      //       },
      //       "FYDC": {
      //         "show": "",
      //         "model": [
      //           {
      //             "type": "dividerConter",
      //             "value": "{{title}}",
      //             "float": 1
      //           },
      //           {
      //             "type": "loop",
      //             "value": {
      //               "source": "payItems",
      //               "model": [
      //                 {
      //                   "type": "textarea",
      //                   "value": [
      //                     {
      //                       "value": "{{collectionInfo}}",
      //                       "isShowIndex": true
      //                     }
      //                   ]
      //                 },
      //                 {
      //                   "type": "text",
      //                   "value": "交易账户：{{accountName}}",
      //                   "isShow": true
      //                 }
      //               ]
      //             }
      //           }
      //         ]
      //       },
      //       "FXYQ": {
      //         "show": "",
      //         "model": [
      //           {
      //             "type": "dividerConter",
      //             "value": "{{title}}",
      //             "float": 1
      //           },
      //           {
      //             "type": "loop",
      //             "value": {
      //               "source": "payItems",
      //               "model": [
      //                 {
      //                   "type": "textarea",
      //                   "value": [
      //                     {
      //                       "value": "{{collectionInfo}}",
      //                       "isShowIndex": true
      //                     }
      //                   ]
      //                 },
      //                 {
      //                   "type": "text",
      //                   "value": "交易账户：{{accountName}}",
      //                   "isShow": true
      //                 }
      //               ]
      //             }
      //           }
      //         ]
      //       },
      //       "JHD": {
      //         "show": "",
      //         "model": [
      //           {
      //             "type": "dividerConter",
      //             "value": "{{title}}",
      //             "float": 1
      //           },
      //           {
      //             "type": "loop",
      //             "value": {
      //               "source": "payItems",
      //               "model": [
      //                 {
      //                   "type": "textarea",
      //                   "value": [
      //                     {
      //                       "value": "{{collectionInfo}}",
      //                       "isShowIndex": true
      //                     }
      //                   ]
      //                 },
      //                 {
      //                   "type": "text",
      //                   "value": "交易账户：{{accountName}}",
      //                   "isShow": true
      //                 }
      //               ]
      //             }
      //           }
      //         ]
      //       },
      //       "JRD": {
      //         "show": "",
      //         "model": [
      //           {
      //             "type": "dividerConter",
      //             "value": "{{title}}",
      //             "float": 1
      //           },
      //           {
      //             "type": "loop",
      //             "value": {
      //               "source": "payItems",
      //               "model": [
      //                 {
      //                   "type": "textarea",
      //                   "value": [
      //                     {
      //                       "value": "{{collectionInfo}}",
      //                       "isShowIndex": true
      //                     }
      //                   ]
      //                 },
      //                 {
      //                   "type": "text",
      //                   "value": "交易账户：{{accountName}}",
      //                   "isShow": true
      //                 }
      //               ]
      //             }
      //           }
      //         ]
      //       },
      //       "JOD": {
      //         "show": "",
      //         "model": [
      //           {
      //             "type": "dividerConter",
      //             "value": "{{title}}",
      //             "float": 1
      //           },
      //           {
      //             "type": "loop",
      //             "value": {
      //               "source": "payItems",
      //               "model": [
      //                 {
      //                   "type": "textarea",
      //                   "value": [
      //                     {
      //                       "value": "{{collectionInfo}}",
      //                       "isShowIndex": true
      //                     }
      //                   ]
      //                 },
      //                 {
      //                   "type": "text",
      //                   "value": "交易账户：{{accountName}}",
      //                   "isShow": true
      //                 }
      //               ]
      //             }
      //           }
      //         ]
      //       }
      //     }
      //   },
      //   {
      //     "type": "dividerConter",
      //     "value": "收款合计",
      //     "float": 1
      //   },
      //   {
      //     "type": "textarea",
      //     "value": [
      //       {
      //         "value": "销售总价：{{saleTotalAmt}}",
      //         "isShow": true
      //       },
      //       {
      //         "value": "退货总价：{{returnTotalAmt}}",
      //         "isShow": true
      //       }
      //     ]
      //   },
      //   {
      //     "type": "textarea",
      //     "value": [
      //       {
      //         "value": "订货总额：{{meetTotalAmt}}",
      //         "isShow": true
      //       },
      //       {
      //         "value": "费用总额：{{feeTotalAmt}}",
      //         "isShow": true
      //       }
      //     ]
      //   },
      //   {
      //     "type": "textarea",
      //     "value": [
      //       {
      //         "value": "收欠款：{{arrearAmt}}",
      //         "isShow": true
      //       },
      //       {
      //         "value": "收预收：{{prePayAmt}}",
      //         "isShow": true
      //       }
      //     ]
      //   },
      //   {
      //     "type": "textarea",
      //     "value": [
      //       {
      //         "value": "应收金额：{{needPayAmt}}",
      //         "isShow": true
      //       },
      //       {
      //         "value": "优惠金额：{{discountAmt}}",
      //         "isShow": true
      //       }
      //     ]
      //   },
      //   {
      //     "type": "textarea",
      //     "value": [
      //       {
      //         "value": "实收金额：{{payAmt}}",
      //         "isShow": true
      //       }
      //     ]
      //   },
      //   {
      //     "type": "textarea",
      //     "value": [
      //       {
      //         "value": "监督人：{{boss}}",
      //         "isShow": true
      //       },
      //       {
      //         "value": "监督电话：{{bossPhone}}",
      //         "isShow": true
      //       }
      //     ]
      //   },
      //   {
      //     "type": "textarea",
      //     "value": [
      //       {
      //         "value": "业务电话：{{salesmanPhone}}",
      //         "isShow": true
      //       },
      //       {
      //         "value": "签收人：__________",
      //         "show": "signer"
      //       }
      //     ]
      //   },
      //   {
      //     "type": "text",
      //     "value": "出货仓库：{{warehouseName}}"
      //   },
      //   {
      //     "type": "text",
      //     "value": "单据时间：{{billDate}}"
      //   },
      //   {
      //     "type": "text",
      //     "value": "整单备注：{{billRemark}}",
      //     "isShow": true
      //   },
      //   {
      //     "type": "divider",
      //     "value": ""
      //   },
      //   {
      //     "type": "text",
      //     "value": "打印人：{{printUserName}}",
      //     "isShow": true
      //   },
      //   {
      //     "type": "text",
      //     "value": "{{publicRemark}}"
      //   }
      // ]
    },
  }
}
</script>

<style lang="less" scoped>
.flex {
  display: flex;
}
.justify_space-between {
  justify-content: space-between;
}
.center {
  text-align: center;
}

.dividerBox {
  position: relative;
  .divider {
    width: 100%;
    position: absolute;
    top: 50%;
  }
  span {
    background-color: #fff;
    position: relative;
  }
}
.divider {
  height: 1px;
  border-top: 1px dashed #000;
}

.tableHead {
  display: flex;
}
.tableBody .product {
  .td + .td {
    margin-left: 12px;
  }
}
.th, .td {
  flex-shrink: 0;
  text-align: center;
  flex: 1;
}
</style>